{
  "translation": {
    "ai_templates": {
      "menu_title_pet": "うちの子アート",
      "menu_title_family": "ファミリーフォト",
      "menu_title_kids": "キッズルームアート",
      "menu_title_places": "風景アート",
      "menu_title_travel_posters": "旅のポスター",
      "menu_title_vintage_posters": "ヴィンテージポスター",
      "menu_title_home_hobbies": "暮らしと趣味",
      "menu_title_kitchen_art": "キッチンアート",
      "menu_title_food_drink_art": "フード＆ドリンクアート",
      "menu_title_food_recipe_art": "フード＆レシピアート",
      "menu_title_travel": "旅",
      "variants": {
        "boy": "男の子",
        "girl": "女の子"
      },
      "faces_selection": {
        "title": "顔を選択",
        "subtitle": "目と髪がはっきり写っている写真をお選びください",
        "no_faces_detected": "顔が検出されませんでした",
        "generate_button": "写真を生成（{{count}}{{label}}）",
        "person": "人",
        "people": "人",
        "pet": "匹",
        "pets": "匹",
        "portraits": "点"
      },
      "multi_upload": {
        "title": "きれいに仕上げるために",
        "cta": "1〜9枚の写真をアップロード"
      },
      "kids_wall": {
        "child_name": "お子さまの名前",
        "interests_label": "好きなものを2〜3つ教えてください",
        "interests_placeholder": "例：恐竜、サッカー、ユニコーン",
        "interests_hint": "商標登録されたキャラクターはご遠慮ください"
      },
      "upload_menu": {
        "create": "作成",
        "text_input_title": "ペットの名前（任意）",
        "processing": "処理中...",
        "upload_photo": "写真をアップロード",
        "cta": {
          "upload_pet_photo": "ペットの写真をアップロード",
          "upload_couple_photo": "カップルの写真をアップロード",
          "upload_old_photo": "昔の写真をアップロード",
          "upload_photo_with_faces": "顔が写った写真をアップロード",
          "upload_scenic_photo": "風景写真をアップロード",
          "upload_family_photo": "家族写真をアップロード"
        }
      },
      "results": {
        "add_tile": "タイルを追加",
        "next": "次へ"
      },
      "loading": {
        "creating_photos": "写真を作成中..."
      },
      "variations": {
        "generation_failed": "新しいスタイルを作成できませんでした。もう一度お試しください。",
        "create_button_one": "ポートレートを{{count}}枚作成",
        "create_button_other": "ポートレートを{{count}}枚作成",
        "add_portraits_line_1": "ポートレートを",
        "add_portraits_line_2": "追加",
        "add_portraits_for_pet": "ペットのポートレートを追加",
        "change_pet_photo": "ペットの写真を変更",
        "back_to_add_options": "追加オプションに戻る",
        "load_failed": "スタイルを読み込めませんでした。もう一度お試しください。",
        "no_more_templates": "このペット用のテンプレートはもうありません",
        "generating_snackbar": "作成中"
      },
      "errors": {
        "unexpected_error": "画像の生成に失敗しました",
        "safety_reject": "安全上の理由により画像が拒否されました",
        "service_unavailable": "生成に失敗しました：サービスが一時的に利用できません",
        "image_too_large": "生成に失敗しました：画像サイズが大きすぎます",
        "image_processing_failed": "生成に失敗しました：画像を処理できませんでした",
        "rate_limit": "本日のリクエスト上限に達しました。明日もう一度お試しください。"
      }
    },
    "art": {
      "home": {
        "cta_browse": "アートを探す",
        "subtitle": "好きなアートをピタッと飾ろう",
        "title": "一瞬で、\n壁がギャラリーに",
        "title_with_category": "{{v1}} コレクション"
      },
      "collection": {
        "categories": {
          "Best Sellers": "人気商品",
          "Animals": "動物",
          "Sayings": "ことばアート",
          "Plants": "植物",
          "Beach": "ビーチ",
          "Abstract": "抽象画",
          "Lines": "線画",
          "Famous Artists": "名画",
          "Geometric": "幾何学模様",
          "Flowers": "花",
          "Classic Art": "クラシックアート",
          "Kitchen": "キッチン",
          "Kids": "キッズ",
          "Botanical": "ボタニカル",
          "Destinations": "旅先",
          "Urban": "街並み",
          "Mountains": "山",
          "Faith": "聖書のことば",
          "Nature": "自然",
          "Travel": "トラベル",
          "Dogs & Cats": "犬＆猫"
        }
      },
      "select_art": "アートを選ぶ"
    },
    "business": {
      "add_emails": "メールアドレスを追加",
      "company_name": "会社名",
      "contact_form_title": "以下のフォームにご記入ください。担当者より折り返しご連絡いたします。",
      "csv": "CSVをアップロード",
      "desired_amount_of_tiles": "ご希望のタイル数",
      "employees_gift_cards": "従業員向けギフトカード",
      "employees_to_be_gifted": "ギフト対象の従業員数",
      "gift_card_for_title": "デジタルギフトカード（まとめ買い割引あり）",
      "submit": {
        "subtitle": "担当者より折り返しご連絡いたします",
        "title": "ありがとうございます！リクエストを受け付けました"
      },
      "subtitle": "カスタムフォトタイルの美しさと手軽さをご体験ください。法人向け特別パッケージでは、割引価格と専門スタッフによるサポートをご提供しています。",
      "title": "法人のお客様へ",
      "your_name": "お名前"
    },
    "centerpiece": {
      "add_wall_sign": "壁掛けプレートを追加",
      "bottom_text": "下のテキスト",
      "customize": "カスタマイズ",
      "top_text": "上のテキスト"
    },
    "download_app": {
      "card": {
        "title": "ギャラリーウォールが完成しました！",
        "subtitle": "アプリがベストショットから素敵なギャラリーウォールを作ります"
      },
      "hero": {
        "title": "フォトブックが完成しました！",
        "subtitle": "アプリがベストショットから素敵なフォトブックを作ります"
      },
      "cta": "アプリをダウンロード"
    },
    "collage": {
      "add_more": "コラージュを作るには、さらに写真を追加してください",
      "collage": "コラージュ",
      "edit_collage": "編集",
      "exceeding_photos": {
        "choose_photos_plural": "このレイアウトには{{v1}}枚の写真を選んでください",
        "choose_photos_singular": "このレイアウトには1枚の写真を選んでください",
        "select_more_photos_plural": "あと{{v1}}枚選んでください",
        "select_more_photos_singular": "あと1枚選んでください"
      },
      "layout_rearrange_notice": "レイアウトが変更されます",
      "text_limit_reached": "テキストの文字数上限に達しました",
      "text_unsupported_size": "テキストを追加するにはサイズを変更してください"
    },
    "designer": {
      "add_tile_or_collage_to_enable_bulk_editing": "一括編集するにはタイルまたはコラージュを追加してください",
      "add_tile_to_enable_bulk_editing": "一括編集するにはタイルを追加してください",
      "adjust_crop_description": "ピンチで拡大、ドラッグで移動",
      "adjust_crop_description_desktop": "スクロールで拡大、ドラッグで移動",
      "adjust_crop_hint": "ピンチまたはドラッグでトリミングを調整",
      "adjust_crop_hint_desktop": "ドラッグでトリミングを調整",
      "bad_crop": {
        "approve_btn": "確認して注文する",
        "back_btn": "戻る",
        "desktop_subtitle": "スクロールで拡大、ドラッグで移動",
        "edit": "注文全体を編集",
        "mobile_subtitle": "ピンチで拡大、ドラッグで移動",
        "next_btn": "次へ",
        "review_btn": "写真を確認",
        "title": "写真のトリミングをご確認ください"
      },
      "border": "フチ",
      "bulk_override_warning": {
        "apply_filter": "フィルターを適用",
        "apply_frame_color": "フレームを適用",
        "apply_mat": "台紙を適用",
        "apply_material": "素材を適用",
        "apply_size": "サイズを適用",
        "apply_to_all": "すべてに適用",
        "title": "この{{style}}をすべてのタイルに適用しますか？"
      },
      "change_mat": "台紙を変えて仕上がりイメージを確認してみてください",
      "choose_swap": "入れ替える写真を選んでください",
      "color": "カラー",
      "crop": "トリミング",
      "delete": "削除",
      "duplicate": "複製",
      "drop_files": "写真をドロップしてアップロード",
      "effect": "効果",
      "excellent_quality": {
        "cta": "了解",
        "subtitle": "問題がある場合はお知らせします",
        "title": "写真の画質は良好です！"
      },
      "change_mat_notifications": {
        "partial_apply": {
          "title": "フチが一部適用されました",
          "single_material_subtitle": "{{v1}}はフチに対応していません",
          "generic_material_subtitle": "一部のタイルはフチに対応していません"
        },
        "disabled": "他のフレームタイプで利用可能です"
      },
      "filter": "フィルター",
      "wide": "ワイド",
      "frame": "フレーム",
      "frameless_8x8_caption": "{{v1}}のみ",
      "layout": "レイアウト",
      "mat": "台紙",
      "material": "素材",
      "matting": "台紙加工",
      "mixed_sizes": "サイズミックス",
      "out_of_stock_warning": {
        "approve": "{{size}}に変更",
        "cancel": "{{material}}のまま",
        "product_approve": "{{product}}に変更",
        "product_cancel": "{{product}}のまま",
        "product_title": "{{product}}は在庫切れです",
        "title": "{{size}} {{material}}タイルは在庫切れです",
        "out_of_stock": "在庫切れ"
      },
      "photos": "写真",
      "progress_bar": {
        "adding_photos": "写真を追加中...",
        "framing_your_photos": "写真をフレームに入れています…"
      },
      "recommended_size": "{{v1}}以下を推奨",
      "select_border": "フチを選ぶ",
      "select_color": "カラーを選ぶ",
      "select_effect": "効果を選ぶ",
      "select_filter": "フィルターを選ぶ",
      "select_frame": "フレームを選ぶ",
      "select_frame_color": "フレームの色を選ぶ",
      "select_layout": "レイアウトを選ぶ",
      "select_mat": "台紙を選ぶ",
      "select_material": "素材を選ぶ",
      "select_matting": "台紙加工を選ぶ",
      "select_size": "サイズを選ぶ",
      "select_style": "スタイルを選ぶ",
      "select_text_style": "テキストスタイルを選ぶ",
      "handwriting": "手書き風",
      "classic": "クラシック",
      "bold": "太字",
      "size": "サイズ",
      "swap_positions": "位置を入れ替え",
      "text": "テキスト",
      "tile_deleted": "タイルを削除しました"
    },
    "general": {
      "address_form": {
        "add_title": "住所を追加",
        "change_save": "更新",
        "change_title": "住所を変更",
        "form_fields": {
          "address": "住所",
          "address_2": "建物名・部屋番号",
          "city": "市区町村",
          "country": "国",
          "full_name": "氏名",
          "full_name_kana": "氏名フリガナ",
          "full_name_kana_placeholder": "下の氏名欄のフリガナをカタカナで入力してください。",
          "phone": "電話番号",
          "postal": "郵便番号",
          "province": "都道府県",
          "state": "都道府県",
          "state_or_province": "都道府県",
          "state_or_territory": "都道府県",
          "zip": "郵便番号"
        },
        "phone_number_info": "住所確認のため、配送会社（UPS等）から電話や\nショートメッセージで連絡が入る場合があります。",
        "suggest_offers": "お得な情報をSMSで受け取る",
        "suggest_offers_email": "お得な情報をメールで受け取る",
        "re_enter_address": "住所を再入力",
        "use_this_address_anyway": "この住所を使用する",
        "validation_errors": {
          "address": {
            "invalid": "市区町村・都道府県・郵便番号をご確認ください",
            "not_found": "住所が見つかりません",
            "not_supported": "申し訳ございません。お客様の国では{{product}}のご注文を承っておりません"
          },
          "city_state": {
            "invalid": "市区町村または都道府県をご確認ください"
          },
          "country": {
            "unsupported": "申し訳ございません。お客様の国への配送は現在対応しておりません"
          },
          "email": {
            "invalid": "有効なメールアドレスをご入力ください"
          },
          "full_name": {
            "invalid": "氏名（姓・名）をご入力ください"
          },
          "full_name_kana": {
            "missing": "氏名フリガナをカタカナでご入力ください",
            "invalid": "フリガナはひらがなまたはカタカナでご入力ください"
          },
          "non_latin_characters": "半角英数字でご入力ください",
          "house_number": {
            "invalid": "番地をご確認ください",
            "missing": "番地が入力されていません"
          },
          "missing_fields": {
            "general": "必須項目をすべてご入力ください",
            "specific": "{{v1}}をご入力ください"
          },
          "name": {
            "invalid": "お名前をご入力ください",
            "too_long": "お名前は{{v1}}文字以内でご入力ください"
          },
          "phone": {
            "invalid": "有効な電話番号をご入力ください"
          },
          "secondary_information": {
            "invalid": "建物名・部屋番号をご確認ください",
            "missing": "建物名・部屋番号が入力されていません"
          },
          "state": {
            "invalid": "都道府県をご確認ください"
          },
          "street": {
            "invalid": "町名をご確認ください",
            "missing": "町名が入力されていません",
            "po_box": "私書箱への配送はできません"
          },
          "mind_another_look": "もう一度ご確認いただけますか？",
          "zip": {
            "invalid": "郵便番号をご確認ください",
            "not_found": "郵便番号が見つかりません",
            "state_mismatch": "郵便番号と都道府県が一致しません",
            "unsupported_territory": "この地域へは配送できません"
          }
        }
      },
      "applied": "適用済み",
      "auto_save_message": "保存しました",
      "best_seller": "人気商品",
      "add": "追加",
      "cancel": "キャンセル",
      "discard_changes": "変更を破棄",
      "done": "完了",
      "each": "/個",
      "errors": {
        "dark_mode_subTitle": "正確な色を表示するにはライトモードに切り替えてください",
        "dark_mode_title": "ダークモードではフレームの色が正しく表示されません",
        "general_description": "ご不便をおかけして申し訳ございません。もう一度お試しいただき、問題が続く場合はお知らせください。",
        "general_description_short": "もう一度お試しください",
        "general_title": "エラーが発生しました",
        "general_title_short": "エラーが発生しました",
        "order_cancelled_title": "ご注文がキャンセルされました",
        "order_cancelled_refund_subtitle": "返金手続き中です",
        "webgl_not_supported_subtitle": "Safari または Chrome でこのページを開くと、プレビューを表示できます。",
        "webgl_not_supported_title": "このブラウザではプレビューを表示できません"
      },
      "from_price": "{{v1}}〜",
      "gdpr_dialog": {
        "privacy_policy": "プライバシーポリシー",
        "terms_of_use": "利用規約"
      },
      "got_it": "了解",
      "languages": {
        "change_language": "言語を変更",
        "de": "Deutsch",
        "en": "English",
        "es": "Español",
        "fr": "Français",
        "ja": "日本語",
        "language": "言語"
      },
      "learn_more": "詳しく見る",
      "menu": {
        "accessibility_button": "アクセシビリティ",
        "add_promo_code": {
          "modal": {
            "form_title": "コード",
            "placeholder": "ここに入力",
            "title": "プロモコードを入力",
            "title_with_gift_card": "プロモコードまたはギフトカードを入力"
          },
          "success": {
            "code_applied": "{{v1}} 適用済み"
          }
        },
        "art_collection": "アートコレクション",
        "buy_gift_card": "ギフトカードを購入",
        "chat_with_us": "チャットで相談",
        "faq": "よくある質問",
        "for_business": "法人のお客様",
        "frame_your_photos": "タイルをデザイン",
        "gift_card": "ギフトカード",
        "gift_card_v2": "ギフトカード",
        "help_center": "ヘルプセンター",
        "my_orders": "注文履歴",
        "privacy_policy": "プライバシーポリシー",
        "cookie_policy": "Cookieポリシー",
        "promo_code_manager": {
          "promo_codes": "プロモコード"
        },
        "use_code_to_save": "コード「{{v1}}」適用済み、最大{{v2}}%OFF（サイズ・素材により割引率は異なります）"
      },
      "new": "NEW",
      "ok": "OK",
      "optional": "任意",
      "payment_form": {
        "header": "請求先住所",
        "same_shipping_address": "請求先住所と配送先住所は同じ",
        "validation_errors": {
          "address": {
            "missing": "住所をご入力ください"
          },
          "missing_fields": {
            "general": "お支払い情報をご入力ください"
          }
        }
      },
      "promo_code_selector": {
        "default": "デフォルト",
        "disclaimer": "割引率はサイズ・素材により異なります",
        "free_tile_description": "{{v2}}タイル{{v1}}枚無料",
        "free_book_description": "{{v2}}ブック{{v1}}冊無料",
        "free_tiles": "無料タイル",
        "free_books": "無料ブック",
        "gift_card_description": "{{v1}}クレジット（残高{{v2}}）",
        "promo_not_applied_to_product": "このプロモは{{v1}}に適用されません",
        "select_volume_discount": "割引を選択",
        "volume_discount_applied": "まとめ買い割引が適用されました"
      },
      "promo_code_success_dialog": {
        "call_to_action": "商品を見る",
        "save_message_on_product": "{{v2}}が{{v1}}OFF",
        "save_up_to_message_shortened": "最大{{v1}}%OFF",
        "size_and_material_disclaimer": "最大{{v1}}%OFF（サイズ・素材により割引率は異なります）",
        "subtitle": {
          "gift_card": "{{v1}}が追加されました",
          "gift_card_tiles_many": "{{v1}}枚の無料タイル",
          "gift_card_tiles_one": "1枚の無料タイル",
          "gift_card_books_many": "{{v1}}冊の無料フォトブック",
          "gift_card_books_one": "1冊の無料フォトブック"
        },
        "title": {
          "bundle": "{{v1}}枚{{size_constraint}}タイルが{{v2}}",
          "free_tiles_many": "{{v1}}枚{{size_constraint}}の無料タイルをゲット！",
          "gift_card": "ギフトカードが適用されました！"
        }
      },
      "refresh": "更新",
      "skip": "スキップ",
      "start_creating": "作成をはじめる",
      "continue_design": "デザインする",
      "talk_to_us": "お問い合わせ",
      "try_again": "もう一度試す",
      "credits": {
        "balance": "{{v1}}のクレジットがあります"
      }
    },
    "google_photos": {
      "authorize_title": "Googleフォトと連携",
      "authorize": "ログイン",
      "select_title": "新しいタブでGoogleフォトを開いて写真を選択してください",
      "select_photos": "新しいタブで開く",
      "error_title": "エラー",
      "error_message": "エラーが発生しました。もう一度お試しください。",
      "try_again": "もう一度試す",
      "fetching_title": "選択した写真を取得中",
      "step_1": "ステップ 1",
      "step_2": "ステップ 2",
      "adding_photos": "写真を追加中",
      "google_photos_requires_safari": "GoogleフォトはSafariで開く必要があります",
      "open_safari": "Safariで開く",
      "stay_here": "このまま",
      "disconnect": "Googleフォトとの連携を解除"
    },
    "get_started": {
      "form_fields": {
        "email": "メールアドレス"
      },
      "title": "はじめましょう"
    },
    "gift_card": {
      "books": "ブック",
      "buy_now": "今すぐ購入",
      "delivered_by_email_with_expiry": "メールでお届け、有効期限なし",
      "form": {
        "add_email_address": "メールアドレスを追加",
        "card_value_label": "カードの金額を選択",
        "choose_book_size": "ブックサイズを選択",
        "custom_placeholder": "カスタム",
        "design_label": "デザインを選択",
        "gift_message_label": "ギフトメッセージ（任意）",
        "gift_message_placeholder": "メッセージを入力",
        "gift_scheduler_label": "ギフトカードの送信日を選択",
        "now": "今すぐ",
        "recipient_email_placeholder": "受取人のメールアドレス",
        "recipient_label": "誰に贈りますか？",
        "sender_label": "贈り主のお名前",
        "sender_name_placeholder": "贈り主の名前",
        "today": "今日"
      },
      "number_of_books": "{{v1}}冊、{{v2}}",
      "number_of_tiles": "{{v1}}枚",
      "prepay_save_up_to": "まとめ買いで最大{{v1}}%お得",
      "prepay_save_exact": "まとめ買いで{{v1}}%お得",
      "sizes_note_2": "{{v1}}フレームまたはフレームレスのみ対応",
      "switch_gift_card_type_cta": "切り替え",
      "switch_to_tile_based_description": "枚数で選べるギフトカードに切り替え",
      "switch_to_value_based_description": "金額で選べるギフトカードに切り替え。すべてのサイズ・素材に対応。",
      "tiles": "タイル",
      "title_digital": "デジタルギフトカード",
      "your_email": "あなたのメールアドレス"
    },
    "holidays": {
      "arrives_before_christmas": "クリスマスまでにお届け 🎄",
      "arrives_before_fathers_day": "父の日までにお届け",
      "arrives_before_mothers_day": "母の日までにお届け",
      "arrives_before_valentines_day": "バレンタインデーまでにお届け",
      "arrives_before_veterans_day": "退役軍人の日までにお届け",
      "get_it_by_christmas": "クリスマスまでにお受け取り 🎄",
      "get_it_by_fathers_day": "父の日までにお受け取り",
      "get_it_by_mothers_day": "母の日までにお受け取り",
      "get_it_by_valentines_day": "バレンタインデーまでにお受け取り",
      "get_it_by_veterans_day": "退役軍人の日までにお受け取り"
    },
    "homepage": {
      "photo_books_banner": {
        "subtitle": "海外で話題！\n今すぐ注文",
        "cta": "試してみる"
      },
      "beauty": {
        "subtitle": "すべてのブックはマット仕上げのハードカバー。シルクのようになめらかな手触りの上質な紙を使用しています。",
        "title": "ページをめくるたび、美しさを",
        "design_subtitle": "旅ごとに特別にデザインされたハードカバー。上質な印刷とシルク仕上げのページで、いつまでも色あせないコレクションに。",
        "design_title": "集めたくなるデザイン",
        "life_events_subtitle": "美しく仕上げたハードカバー。上質な印刷とシルク仕上げのページで、いつまでも大切にできるコレクションに。",
        "life_events_title": "集めたくなるデザイン"
      },
      "chat": {
        "content": "日本語サポート対応。\nお気軽にご相談ください",
        "cta": "チャットで相談",
        "title": "お困りですか？"
      },
      "community": {
        "subtitle_black_frames": "ブラック {{v1}} フレーム",
        "subtitle_white_frames": "ホワイト {{v1}} フレーム",
        "subtitle_wood_frames": "ウッド {{v1}} フレーム",
        "subtitle_wood_mixed_frames": "木製フレーム サイズいろいろ",
        "title": "みんなの飾り方"
      },
      "cookies_choices": "プライバシー設定",
      "covered": {
        "rated": "評価 {{v1}}",
        "rated_subtitle": "App Storeで12万件以上の評価",
        "reviews": "レビュー",
        "shipping": "送料無料＆スピード配送",
        "shipping_subtitle": "※{{v1}}以上のご注文で送料無料",
        "shipping_free_subtitle": "最低注文金額なし",
        "support": "安心のカスタマーサポート",
        "support_short": "安心サポート",
        "support_subtitle": "専門スタッフが対応いたします",
        "title": "Mixtilesが選ばれる理由",
        "trustpilot": "Trustpilotで高評価"
      },
      "faq": {
        "frames": {
          "content": "サイズは{{v1}}から{{v2}}まで、さらにユニークな{{v3}}サイズもございます。さまざまな素材とフレームカラーからお選びいただけます。",
          "title": "タイルのサイズはどのくらいですか？"
        },
        "frames-art": {
          "content": "サイズは{{v1}}から{{v2}}まで。さまざまな素材とフレームカラーからお選びいただけます。",
          "title": "タイルのサイズはどのくらいですか？"
        },
        "move-tiles": {
          "content": "独自開発の粘着パッドで簡単に取り付けられます。壁に傷をつけないため、賃貸のお部屋でも安心してお使いいただけます。",
          "title": "取り付けは簡単ですか？"
        },
        "photo-books-customize": {
          "content": "簡単です！1ページ1枚の写真レイアウトで、すべての思い出にスポットライトを当てます。表紙にはお気に入りの写真を選び、テキストの編集や削除も自由自在。ドラッグ操作で各ページの写真の位置調整や順番の変更もでき、あなたの思い描くストーリーを一冊に仕上げられます。",
          "title": "フォトブックはどのようにカスタマイズできますか？"
        },
        "photo-books-delivery": {
          "content": "フォトブックは、ご注文から通常{{delivery_time}}営業日以内を目安にお届けします。ご注文確定前に、チェックアウトページでお届け予定日をご確認いただけますのでご安心ください。配送はUPSにて、送料無料でお届けします。",
          "title": "フォトブックはどのくらいで届きますか？"
        },
        "photo-books-discount": {
          "content": "フォトブックは新商品のため、一部のMixtiles割引はまだ適用されません。ただし、Mixtilesクレジットやバリューギフトカードはフォトブックのご購入にお使いいただけます！",
          "title": "Mixtilesの割引コードはフォトブックにも使えますか？"
        },
        "photo-books-material": {
          "content": "フォトブックはハードカバー仕様で、耐久性に優れています。表紙にはマットフィルム加工、内側のページはシルクのようになめらかな質感の紙を使用し、色を豊かに再現しつつ反射を抑えます。さらに、リサイクル可能な素材を使用しています！",
          "title": "フォトブックはどんな素材で作られていますか？"
        },
        "photo-books-shipment": {
          "content": "日本国内への配送に対応しています。海外（アメリカ、カナダ、イギリス、EU、オーストラリア）にも配送可能です。",
          "title": "フォトブックはどの国に配送できますか？"
        },
        "photo-books-size": {
          "content": "フォトブックは3つのサイズからお選びいただけます：{{v1}}（{{v1_price}}）、{{v2}}（{{v2_price}}）、{{v3}}（{{v3_price}}）。写真の枚数に関わらず価格は同じです！最低25枚から最大{{max_photos}}枚まで収録可能です。",
          "title": "フォトブックのサイズと価格は？"
        },
        "photo-books-size-tiers": {
          "content": "フォトブックは3つのサイズからお選びいただけます：{{v1}}（{{v1_price}}〜）、{{v2}}（{{v2_price}}〜）、{{v3}}（{{v3_price}}〜）。各サイズには、ページ数に応じた3つのシンプルな料金プランがあります：40ページまで、120ページまで、200ページまで。フォトブックには最低25枚の写真が必要で、最大{{max_photos}}枚まで収録できます。",
          "title": "フォトブックのサイズと価格は？"
        },
        "photo-books-wedding-size": {
          "content": "Mixtilesのウェディングフォトブックは{{v1}}、{{v2}}、{{v3}}の3サイズをご用意。特別な日の思い出にぴったりのサイズをお選びください。",
          "title": "ウェディングフォトブックのサイズはどう選べばいいですか？"
        },
        "photo-books-wedding-paper": {
          "content": "Mixtilesでは、ウェディングアルバムをいつまでも残せるよう、シルクのようになめらかな手触りの紙とマット加工のハードカバーを採用しています。耐久性と上質な仕上がりを両立した一冊です。",
          "title": "ウェディングアルバムに最適な紙は？"
        },
        "photo-books-wedding-pages": {
          "content": "ウェディングフォトブックのページ数は、含めたい写真の枚数や詳細さによって変わります。20〜40ページが目安で、結婚式の思い出を網羅的かつコンパクトにまとめられます。",
          "title": "ウェディングフォトブックは何ページが最適ですか？"
        },
        "photo-books-wedding-durability": {
          "content": "高品質な素材で作られたウェディングアルバムは、適切に保管すれば何年もお楽しみいただけます。直射日光や湿気を避けて保管すると、より長持ちします。世代を超えて受け継げる宝物になります。",
          "title": "ウェディングアルバムはどのくらい長持ちしますか？"
        },
        "photo-books-wedding-vs-traditional": {
          "content": "ウェディングフォトブックなら、結婚式の思い出をすっきりとした形で残せます。写真は自動でページに収まり、そのまま注文しやすい形に整うので、作成もスムーズです。さらに写真の並びや見せ方は自由に調整できるため、従来のアルバムより手軽で自分らしい一冊に仕上げられます。",
          "title": "なぜ従来のアルバムではなくフォトブックを作るべきですか？"
        },
        "photo-books-memory-what-is": {
          "content": "思い出フォトブックは、大切な思い出を美しく綴じた写真集です。家族の集まり、旅行、人生の節目など、さまざまな場面の写真をまとめてお楽しみいただけます。Mixtilesでは、あなただけのストーリーを語る特別なフォトブックを作成できます。",
          "title": "思い出フォトブックとは何ですか？"
        },
        "photo-books-memory-create": {
          "content": "Mixtilesでの思い出フォトブック作成はシンプルです。最低24枚、最大{{max_photos}}枚の写真をアップロード。編集ツールで写真の配置、トリミング、ズームを調整できます。1ページ1枚のレイアウトで、すべての思い出が輝きます。ウェブサイトまたはアプリから簡単に注文できます。",
          "title": "思い出フォトブックの作り方は？"
        },
        "photo-books-memory-occasions": {
          "content": "思い出フォトブックは、結婚式、誕生日、記念日、卒業式、年末年始のイベントなど、あらゆるシーンに最適です。大切な方を偲ぶメモリアルブックとしてもお使いいただけます。お祝いの場面にも、大切な方への想いを込めた一冊にも、いつまでも色あせない形で思い出を残せます。",
          "title": "思い出フォトブックはどんな場面に向いていますか？"
        },
        "photo-books-memory-custom": {
          "content": "カスタム思い出フォトブックなら、写真の順番を自由に決められ、あなたのストーリーを思い通りに表現できます。シルクのようになめらかな手触りの紙とマット加工のハードカバーで、長く愛される一冊に仕上がります。",
          "title": "カスタム思い出フォトブックを作るメリットは？"
        },
        "photo-books-memory-pages": {
          "content": "思い出フォトブックは最大{{max_photos}}ページまで作成できます。1ページに1枚ずつ写真を入れられるので、一つひとつの思い出をしっかり引き立てながら、どの写真も美しく見せることができ、コンパクトにまとめることも、たっぷり思い出を残すこともできます。",
          "title": "思い出フォトブックは何ページまで作れますか？"
        },
        "photo-books-memory-cover": {
          "content": "マット加工のハードカバーで、耐久性と上品さを兼ね備えています。表紙には特別な写真を選び、テキストを追加して自分らしい仕上がりに。裏表紙はシンプルで洗練されたデザインです。",
          "title": "思い出フォトブックのカバーの種類は？"
        },
        "photo-books-memory-cost": {
          "content": "思い出フォトブックの価格はサイズとページ数によって異なります。詳しい価格はウェブサイトまたはアプリでご確認ください。",
          "title": "思い出フォトブックの価格は？"
        },
        "photo-books-memory-easiest": {
          "content": "Mixtilesのサイトやアプリから作成するのが最も簡単です。写真をアップロード、配置、編集するだけ。数クリックで素敵なフォトブックが完成します。ご不明な点はチャットまたはメールでサポートいたします。",
          "title": "思い出フォトブックの一番簡単な作り方は？"
        },
        "photo-books-small-sizes": {
          "content": "フォトブックは3つのサイズをご用意：{{v1}}（{{v1_dimensions}}）、{{v2}}（{{v2_dimensions}}）、{{v3}}（{{v3_dimensions}}）。{{v1}}サイズはコンパクトながらおしゃれに思い出を残せます。",
          "title": "ミニフォトブックのサイズは？"
        },
        "photo-books-small-why-choose": {
          "content": "持ち運びやすく、省スペースなフォトブックをお探しの方に最適です。ちょっとしたギフトにもぴったり。コンパクトでも品質に妥協はなく、プレミアム素材で色鮮やかに仕上がります。",
          "title": "なぜミニフォトブックを選ぶのですか？"
        },
        "photo-books-small-occasions": {
          "content": "家族の集まり、旅行、節目の記念など、さまざまなテーマに向いています。ペットの写真集やお子さまの成長記録のようなテーマ別の一冊にもぴったりで、思い出のストーリーをコンパクトにまとめたいときにも最適です。",
          "title": "ミニフォトブックはどんなテーマに向いていますか？"
        },
        "photo-books-small-pages": {
          "content": "24〜{{max_photos}}ページまで収録可能です。1ページに1枚ずつ写真を入れられるので、お気に入りの写真をコンパクトにまとめながら、一つひとつの思い出をしっかり引き立てられます。",
          "title": "ミニフォトブックは何ページまで作れますか？"
        },
        "photo-books-small-customizable": {
          "content": "もちろんです。写真の配置、ズーム、トリミングを自由に調整できるので、思い描いたストーリーに合わせて仕上げられます。表紙も特別な写真とテキストでアレンジでき、あなただけの一冊に仕上がります。",
          "title": "ミニフォトブックはカスタマイズできますか？"
        },
        "photo-books-small-gifts": {
          "content": "はい、コンパクトなフォトブックはギフトに最適です。誕生日、記念日、ホリデーなど、大切な方への心のこもったプレゼントになります。",
          "title": "ミニフォトブックはギフトに向いていますか？"
        },
        "photo-books-small-materials": {
          "content": "Mixtilesのミニフォトブックは高品質な素材で仕上げています。シルクのようになめらかな質感の紙を使用し、反射を抑えつつ色を鮮やかに再現。マット加工のハードカバーで耐久性と高級感を両立しています。",
          "title": "ミニフォトブックはどんな素材を使用していますか？"
        },
        "photo-books-small-story": {
          "content": "テーマに沿った写真を選び、ストーリーの流れに合わせて配置しましょう。Mixtilesの編集ツールでトリミングや調整も簡単。表紙にタイトルを入れて、思い出のストーリーを完成させてください。世界にひとつだけの一冊に仕上がります。",
          "title": "ミニフォトブックで思い出のストーリーを伝えるには？"
        },
        "photo-books-boudoir-what-is": {
          "content": "プライベートフォトブックは、美しさと自信を称えるアーティスティックな写真集です。特別な瞬間と感情を一冊に残せる、世界にひとつだけのフォトブックです。Mixtilesのプレミアムな紙質のページで仕上げた一冊は、めくるたびに大切な瞬間がよみがえります。",
          "title": "プライベートフォトブックとは？なぜ作るのですか？"
        },
        "photo-books-boudoir-select-photos": {
          "content": "まず、あなたの個性やストーリーを反映する写真を選ぶことから始めましょう。さまざまなポーズや表情を組み合わせると、バリエーション豊かな仕上がりに。Mixtilesの編集ツールでズーム、トリミング、配置を自由に調整できます。",
          "title": "プライベートフォトブックにはどの写真を選べばいいですか？"
        },
        "photo-books-boudoir-layout": {
          "content": "視覚的な美しさとストーリー性のバランスを心がけましょう。1ページ1枚のレイアウトで、各写真にスポットライトを。順番を工夫してストーリーを作りましょう。",
          "title": "プライベートフォトブックのレイアウトのコツは？"
        },
        "photo-books-boudoir-size-style": {
          "content": "{{v1}}、{{v2}}、{{v3}}の3サイズから、好みや入れたい写真の枚数に合わせて選べます。マット加工のハードカバーが、プライベートフォトブックにふさわしい上品で洗練された印象を添えます。",
          "title": "プライベートフォトブックのサイズとスタイルの選び方は？"
        },
        "photo-books-boudoir-personalize": {
          "content": "表紙に特別な写真を配置し、テキストでストーリーを表現。あなただけのオリジナルフォトブックに仕上げられます。",
          "title": "プライベートフォトブックを自分らしく仕上げるには？"
        },
        "photo-books-boudoir-cover-materials": {
          "content": "Mixtilesではマット加工のハードカバーを採用。耐久性と上質さを兼ね備え、大切な一冊を長く保護します。",
          "title": "プライベートフォトブックのカバー素材は？"
        },
        "photo-books-boudoir-color-mix": {
          "content": "カラーとモノクロの写真を組み合わせると、深みとコントラストが生まれます。モノクロは感情や細部を際立たせ、カラーは鮮やかさを加えます。Mixtilesのプレミアム印刷でどちらも美しく仕上がります。",
          "title": "カラーとモノクロを混ぜるべきですか？"
        },
        "photo-books-boudoir-order": {
          "content": "Mixtilesのウェブサイトまたはアプリから簡単に注文できます。ワンタップで写真をアップロード・整理。サポートチームもメールやチャットでお手伝いします。",
          "title": "プライベートフォトブックの注文方法は？"
        },
        "photo-books-travel-why-make": {
          "content": "トラベルフォトブックは旅の思い出を形に残す素敵な方法です。Mixtilesなら、あなたの旅を一冊のフォトブックにまとめられます。デジタルアルバムとは違い、手に取ってページをめくる体験が旅の記憶をより鮮やかに蘇らせます。一人旅でも家族旅行でも、あなただけの旅の物語を一冊に。",
          "title": "なぜトラベルフォトブックを作るのですか？"
        },
        "photo-books-travel-features": {
          "content": "地図や旅程を入れてストーリーに奥行きを持たせられます。場所ごとにテキストを添えたり、コメントやメモで各ページをカスタマイズしたりすることも可能です。Mixtilesのサイトやアプリなら、写真やテキストの配置を自由に調整しながら、旅らしさの伝わる一冊に仕上げられます。",
          "title": "トラベルフォトブックにはどんな機能がありますか？"
        },
        "photo-books-travel-cropping": {
          "content": "写真のトリミングと配置は簡単に操作可能。1ページ1枚のレイアウトで、すべての思い出が主役になります。すっきりと洗練されたデザインを維持します。",
          "title": "トラベルフォトブックのトリミングとレイアウトはどうなりますか？"
        },
        "photo-books-travel-details": {
          "content": "Mixtilesのフォトブックには、コメント、日付、場所、旅程の抜粋など、さまざまな旅の情報を追加できます。写真だけでなく、その背景にあるストーリーも伝えられる、あなただけの旅行アルバムに。",
          "title": "トラベルフォトブックにはどんな旅の情報を含められますか？"
        },
        "photo-books-travel-structure": {
          "content": "まず表紙に印象的な写真を選び、時系列またはテーマ別に写真を配置しましょう。風景、文化体験、グルメなどのカテゴリで整理すると、読み応えのある一冊になります。コメントを添えれば、旅の臨場感がさらに伝わります。",
          "title": "トラベルフォトブックをストーリー仕立てにするコツは？"
        },
        "photo-books-travel-quality": {
          "content": "はい、ベルベットのようなシルク質感の紙で色鮮やかに印刷。マット加工のハードカバーが美しさと耐久性を実現。エコフレンドリーな素材を使用しています。",
          "title": "トラベルフォトブックの品質と耐久性は大丈夫ですか？"
        },
        "photo-books-travel-services": {
          "content": "Mixtilesでは、写真が自動でまとまりのあるレイアウトに配置されます。複数のテンプレートはありませんが、写真の順番やトリミングは自由に調整できるので、旅のスタイルに合った一冊に仕上げられます。",
          "title": "トラベルフォトブックのテンプレートや作成方法は？"
        },
        "photo-books-travel-relive": {
          "content": "トラベルフォトブックは単なる写真集ではなく、旅の思い出に浸れる一冊です。ページをめくるたびに旅の感動が蘇ります。友人や家族とシェアして、旅の物語を語り合いましょう。",
          "title": "トラベルフォトブックで旅の思い出を振り返るには？"
        },
        "photo-books-coffee-table-what-is": {
          "content": "飾れるフォトブックは、お気に入りの写真を美しくまとめ、リビングやローテーブルに置いて楽しめる一冊です。ゲストにも手に取って見やすく、会話のきっかけにもなります。Mixtilesなら、大切な思い出をお部屋になじむ上品な一冊として残せます。",
          "title": "飾れるフォトブックとは？なぜ作るのですか？"
        },
        "photo-books-coffee-table-themes": {
          "content": "家族の集まり、旅行、ウェディング、年間の振り返りなどは、飾れるフォトブックにぴったりのテーマです。Mixtilesなら、リビングやローテーブルに置いて楽しめる一冊を、サイトやアプリで写真を整理しながら簡単に作成できます。",
          "title": "飾れるフォトブックに合うテーマは何ですか？"
        },
        "photo-books-coffee-table-design": {
          "content": "飾れるフォトブックは、写真をアップロードして配置するだけで簡単に作成できます。1ページに1枚ずつ写真を入れられるので、それぞれの写真がしっかり引き立ちます。ズーム、トリミング、並べ替えも自由に調整でき、リビングやローテーブルに置きたくなる一冊に仕上げられます。",
          "title": "飾れるフォトブックを魅力的に仕上げるには？"
        },
        "photo-books-coffee-table-travel-wedding": {
          "content": "もちろんです。旅行やウェディングの写真は、飾れるフォトブックにぴったりです。見た目にも美しく、思い出の詰まった一冊になり、リビングやローテーブルに置いて楽しむのにも向いています。Mixtilesの上質な仕上がりなら、大切な思い出をきれいに残せます。",
          "title": "飾れるフォトブックに旅行やウェディングの写真を入れてもいいですか？"
        },
        "photo-books-coffee-table-gifts": {
          "content": "はい、飾れるフォトブックは心のこもったギフトになります。誕生日や記念日などのお祝いにもぴったりで、贈ったあともリビングやローテーブルに置いて楽しめる一冊です。Mixtilesなら、長く大切にできる上質な仕上がりで残せます。",
          "title": "飾れるフォトブックはギフトに向いていますか？"
        },
        "photo-books-coffee-table-year-review": {
          "content": "はい、一年の振り返りをまとめた飾れるフォトブックは、その年の心に残る瞬間を一冊にできる人気の使い方です。Mixtilesなら最大{{max_photos}}枚の写真で、リビングやローテーブルに置いて見返したくなる年間の記録を作れます。",
          "title": "飾れるフォトブックで一年を振り返ることはできますか？"
        },
        "photo-books-coffee-table-guest-house": {
          "content": "はい、飾れるフォトブックはゲストハウスや待合室にもよく合います。地元の魅力や美しい写真をまとめて置いておくことで、訪れた方にも手に取って楽しみやすく、空間づくりにも役立ちます。",
          "title": "飾れるフォトブックはゲストハウスや待合室でも使えますか？"
        },
        "photo-books-coffee-table-suitable": {
          "content": "飾れるフォトブックに向いているのは、見た目の美しさ、耐久性、そして思い出としての意味を兼ね備えた一冊です。Mixtilesなら、上品なデザインと高品質な仕上がりで、リビングやローテーブルに自然になじむフォトブックを作れます。",
          "title": "飾れるフォトブックに向いているのはどんな一冊ですか？"
        },
        "photo-books-engagement-what-is": {
          "content": "婚約フォトブックは、プロポーズから結婚式までのかけがえのない日々を集めた写真集です。ベルベットのようなシルク質感の紙とマット加工のハードカバーで、ふたりの物語を美しく残せます。",
          "title": "婚約フォトブックとは？なぜ作るのですか？"
        },
        "photo-books-engagement-photos-include": {
          "content": "カジュアルなショット、プロの婚約写真、婚約期間中の特別な瞬間など、ふたりの関係を表すさまざまな写真を入れましょう。編集ツールで自由に調整できます。",
          "title": "婚約フォトブックにはどんな写真を入れるべきですか？"
        },
        "photo-books-engagement-proposal": {
          "content": "もちろんです！プロポーズの写真は婚約フォトブックの素晴らしいスタートに。「YES」と答えたあの瞬間の感動を一冊に刻みましょう。Mixtilesで、プロポーズの感動をそのまま一冊に。",
          "title": "婚約フォトブックにプロポーズの写真を入れるべきですか？"
        },
        "photo-books-engagement-party": {
          "content": "婚約パーティーの写真もぜひ入れましょう。大切な人たちとの祝福の瞬間が、フォトブックに喜びと華やかさを添えます。Mixtilesなら最大{{max_photos}}枚まで収録できるので、大切な思い出をたっぷり残せます。",
          "title": "婚約フォトブックに婚約パーティーの写真も入れていいですか？"
        },
        "photo-books-engagement-vs-wedding": {
          "content": "婚約フォトブックはプロポーズから結婚式までの道のりに焦点を当て、ウェディングフォトブックは結婚式当日を記録します。「YES」から結婚式までのストーリーを語る一冊です。",
          "title": "婚約フォトブックとウェディングフォトブックの違いは？"
        },
        "photo-books-engagement-cover-styles": {
          "content": "Mixtilesでは、マット加工のハードカバーで上品さと耐久性を両立。表紙の写真と背表紙のテキストを自由に選んで、ふたりだけの特別な一冊に仕上げられます。",
          "title": "婚約フォトブックのカバーのスタイルと素材は？"
        },
        "photo-books-engagement-story": {
          "content": "プロポーズから結婚式までの写真を時系列に配置して、ふたりの物語を語りましょう。Mixtilesのサイトやアプリなら、写真の配置も簡単です。",
          "title": "「YES」から結婚式までのストーリーを伝えるには？"
        },
        "photo-books-engagement-keepsake": {
          "content": "はい、婚約フォトブックは結婚式でのゲストブックとしても活用できます。ゲストがページをめくりながらふたりの物語を楽しめます。プレミアム品質で長く大切にできる一冊です。",
          "title": "婚約フォトブックは記念品やゲストブックとして使えますか？"
        },
        "photo-books-family-why-create": {
          "content": "ファミリーフォトブックは、大切な家族の思い出を形に残すのにぴったりの方法です。Mixtilesならお気に入りの家族写真を美しく製本された一冊にまとめられ、家族ならではの物語をいつでも振り返れる特別な記念品として残せます。",
          "title": "ファミリーフォトブックを作る理由は？"
        },
        "photo-books-family-formats": {
          "content": "{{v1}}、{{v2}}、{{v3}}の3サイズをご用意。プレミアム品質で、カスタマイズも自由自在です。1ページ1枚のレイアウトで、すべての思い出が主役になります。",
          "title": "ファミリーフォトに最適なフォーマットは？"
        },
        "photo-books-family-organize": {
          "content": "Mixtilesのサイトやアプリで写真をアップロードし、自由に配置できます。トリミングやズームで最適な構図に調整でき、ワンタップで始めてさらにカスタマイズも可能です。",
          "title": "ファミリーフォトブックの写真の整理方法は？"
        },
        "photo-books-family-memories": {
          "content": "日常の何気ない瞬間から特別なイベントまで、幅広い写真を入れましょう。旅行、年末年始のイベント、誕生日、ふとした日常のスナップが、家族の歩みを豊かに語ります。",
          "title": "ファミリーフォトブックにはどんな思い出を入れるべきですか？"
        },
        "photo-books-family-pages": {
          "content": "24〜{{max_photos}}ページで作成できます。1ページに1枚ずつ写真を入れられるので、お好みに合わせて、家族の一年をコンパクトにまとめた一冊にも、思い出をたっぷり詰め込んだ一冊にも仕上げられます。",
          "title": "ファミリーフォトブックは何ページまで作れますか？"
        },
        "photo-books-family-cover-size": {
          "content": "Mixtilesのフォトブックは、マット加工のハードカバーで上質な手触りと耐久性。{{v1}}、{{v2}}、{{v3}}の3サイズからお選びいただけます。",
          "title": "ファミリーフォトブックのカバーとサイズの種類は？"
        },
        "photo-books-family-durable": {
          "content": "シルクのようになめらかな質感の紙とマットフィルムカバーで、いつまでも大切にしたくなる仕上がり。環境にやさしいリサイクル可能な素材を使用しています。",
          "title": "ファミリーフォトブックを長持ちさせるには？"
        },
        "photo-books-family-story": {
          "content": "写真にコメントやエピソードを添えて、家族のストーリーを綴りましょう。表紙の写真とテキストをカスタマイズして、家族の歴史と節目を語る一冊に。",
          "title": "家族の歴史をフォトブックに込めるには？"
        },
        "photo-books-yearly-what-is": {
          "content": "年間フォトブックは、一年の思い出や節目を振り返るための一冊です。大切な瞬間をまとめて残せるので、家族や友人と見返したり、その年の記録として手元に残したりするのに向いています。",
          "title": "年間フォトブックとは？どんな用途に向いていますか？"
        },
        "photo-books-yearly-gather-photos": {
          "content": "月ごとやイベントごとに写真を整理すると、選びやすくなります。Mixtilesのサイトやアプリで簡単にアップロード・配置でき、まとまりのあるストーリーに仕上がります。",
          "title": "年間フォトブック用の写真の集め方は？"
        },
        "photo-books-yearly-what-include": {
          "content": "その年の思い出をたっぷり詰め込みましょう。家族の集まり、旅行、個人的な達成など、1ページ1枚のレイアウトでどの写真もしっかり引き立ちます。Mixtilesの編集ツールでトリミングや配置を調整し、一年の歩みを一冊にまとめられます。",
          "title": "年間フォトブックには何を入れるべきですか？"
        },
        "photo-books-yearly-themes-layouts": {
          "content": "時系列に並べるのが効果的。一年の流れを追いながら、大切な瞬間を順番に紹介できます。1ページ1枚のレイアウトでクリアに見せます。",
          "title": "年間フォトブックにおすすめのテーマやレイアウトは？"
        },
        "photo-books-yearly-formats": {
          "content": "{{v1}}、{{v2}}、{{v3}}の3サイズ。コンパクトなものから大胆なサイズまで、お好みに合わせてお選びいただけます。プレミアム素材のマット加工のハードカバーとシルク質感の紙で仕上げます。",
          "title": "年間フォトブックのフォーマットの種類は？"
        },
        "photo-books-yearly-personalize-cover": {
          "content": "Mixtilesなら表紙のアレンジも簡単です。特別な写真を選び、タイトルを追加して、あなただけの一年を表す表紙に仕上げられます。",
          "title": "カバーを自分らしく仕上げるには？"
        },
        "photo-books-yearly-why-make": {
          "content": "年間フォトブックは、一年の達成やお祝い、何気ない日常のよろこびまで一冊にまとめて残せるのが魅力です。いつでも見返せる耐久性のある一冊として、その年の大切な瞬間を長く保存できます。",
          "title": "なぜ年間フォトブックを作るのですか？"
        },
        "photo-books-yearly-how-often": {
          "content": "毎年の恒例にすることをおすすめします。年々の思い出コレクションが積み重なり、振り返るのがさらに楽しくなります。Mixtilesなら手軽に作れるので、毎年続けやすいのもポイントです。",
          "title": "どのくらいの頻度で作るべきですか？"
        },
        "photo-books-valentines-great-gift": {
          "content": "フォトブックはバレンタインにぴったりのギフト。ふたりの愛の物語をページをめくるたびに振り返れる一冊に。プレミアムな紙質のページで写真が色鮮やかに蘇ります。",
          "title": "なぜフォトブックはバレンタインに最適なギフトですか？"
        },
        "photo-books-valentines-unique-ideas": {
          "content": "「あなたを好きな理由」をテーマに、特別な瞬間の写真にメッセージを添えてみましょう。シンプルな写真集が心に響くラブストーリーに変わります。",
          "title": "バレンタインフォトブックのユニークなアイデアは？"
        },
        "photo-books-valentines-style": {
          "content": "モノクロで統一するとタイムレスで品のある仕上がりに。写真の感情がより引き立ちます。編集ツールで簡単にモノクロ加工できます。",
          "title": "バレンタインフォトブックのスタイリングのコツは？"
        },
        "photo-books-valentines-wedding-photos": {
          "content": "もちろんです！ウェディングフォトは最もロマンティックな瞬間のひとつ。1ページ1枚のレイアウトで結婚式のハイライトも美しく見せられます。",
          "title": "バレンタインフォトブックにウェディングフォトを入れてもいいですか？"
        },
        "photo-books-valentines-focus": {
          "content": "ロマンティックな瞬間や関係を象徴する思い出に焦点を。初デート、思い出の旅行、日常のふとした瞬間も、ふたりのストーリーを彩ります。Mixtilesの編集ツールで自由に配置して、ふたりだけの一冊に仕上げましょう。",
          "title": "バレンタインフォトブックでは何を中心に選べばいいですか？"
        },
        "photo-books-valentines-fun-personal": {
          "content": "自然体のスナップとポーズ写真を組み合わせましょう。自然な笑顔と特別な瞬間のバランスで、Mixtilesのワンタップ作成機能を使って、あなただけのオリジナルな一冊に仕上げましょう。",
          "title": "バレンタインフォトブックを楽しく自分らしく仕上げるには？"
        },
        "photo-books-valentines-suitable-couples": {
          "content": "はい、新婚カップルにも長年連れ添ったご夫婦にもぴったり。どんな段階のカップルにも、ふたりの歩みを祝う、丈夫で長く大切にできる一冊になります。",
          "title": "バレンタインフォトブックはどんなカップルにも合いますか？"
        },
        "photo-books-valentines-gather-content": {
          "content": "ラブレター、お気に入りの写真、心に残る言葉を集めましょう。スマホにフォルダを作って準備し、最低24枚の写真で心のこもった一冊を作成できます。",
          "title": "バレンタインフォトブックのコンテンツの集め方は？"
        },
        "photo-books-graduation-why-create": {
          "content": "人生の大切な節目を形に残す卒業フォトブック。Mixtilesなら、入学から卒業までの道のりを一冊の記念品に仕上げられます。",
          "title": "卒業フォトブックを作る理由は？"
        },
        "photo-books-graduation-what-photos": {
          "content": "入学初日のワクワク感、卒業式の誇らしい瞬間、友人との思い出、学生時代のイベントなど。成長の軌跡を幅広く盛り込みましょう。",
          "title": "卒業フォトブックにはどんな写真を盛り込むべきですか？"
        },
        "photo-books-graduation-organize": {
          "content": "時系列またはテーマ別に整理できます。編集ツールで写真の配置を自由にカスタマイズし、あなただけのストーリーを語りましょう。",
          "title": "写真の整理方法は？"
        },
        "photo-books-graduation-how-many-photos": {
          "content": "最低24枚、最大{{max_photos}}枚まで収録可能。スマホ、SNS、友人から写真を集めて、卒業の思い出を網羅的にまとめましょう。",
          "title": "何枚の写真が必要ですか？"
        },
        "photo-books-graduation-design-theme": {
          "content": "お好みのスタイルや伝えたいストーリーに合わせてテーマを選びましょう。マット加工のハードカバーとシルクのようになめらかな質感の紙で、落ち着いたデザインから華やかなデザインまで幅広く対応し、写真が色鮮やかにプレミアム品質で仕上がります。",
          "title": "卒業フォトブックのデザインテーマの選び方は？"
        },
        "photo-books-graduation-quotes-messages": {
          "content": "はい、思い出のことばやメッセージを添えて、自分らしい一冊に仕上げられます。QRコードも画像としてアップロードすれば追加可能です。",
          "title": "卒業フォトブックにメッセージや好きなことば、QRコードを入れられますか？"
        },
        "photo-books-graduation-sort-upload": {
          "content": "Mixtilesなら、ワンタップで写真が自動的にページに配置され、そのまま注文しやすい形に整います。さらに自由にカスタマイズして、各ページに自分らしい工夫を加えられます。",
          "title": "卒業フォトブックの写真のアップロードと並び替えは？"
        },
        "photo-books-graduation-templates-layouts": {
          "content": "1ページ1枚のレイアウトで、すべての思い出にスポットライト。シンプルで効果的なデザインで卒業の軌跡を美しく見せつつ、編集ツールでトリミングや並び替えも自由にできます。",
          "title": "卒業フォトブックにおすすめのレイアウトは？"
        },
        "photo-books-birthday-important-moments": {
          "content": "ケーキカット、プレゼント開封、ゲストとの交流など、お祝いのハイライトを中心に。誕生日の喜びと興奮が伝わる写真を選びましょう。Mixtilesのフォトブックなら、ページをめくるたびに大切な思い出がよみがえります。",
          "title": "バースデーフォトブックで大切な瞬間は？"
        },
        "photo-books-birthday-photograph-party": {
          "content": "全体の雰囲気がわかる引きの写真と、デコレーションや表情のクローズアップを組み合わせましょう。シルク質感の紙で細部まで美しく仕上がります。",
          "title": "パーティーの撮影のコツは？"
        },
        "photo-books-birthday-candid-vs-posed": {
          "content": "ポーズ写真も素敵ですが、自然体のスナップがパーティーの本当の楽しさを伝えます。笑顔やサプライズ、ゲスト同士が楽しむ瞬間を中心に撮りましょう。Mixtilesの編集機能を使えば、お祝いの雰囲気がそのまま伝わるフォトブックに仕上げられます。",
          "title": "自然体の写真とポーズ写真、どちらがいいですか？"
        },
        "photo-books-birthday-details-include": {
          "content": "飾り付け、バースデーケーキ、参加者の笑顔など、パーティーの空気感が伝わるカットを入れましょう。Mixtilesのフォトブックなら、1ページ1枚のレイアウトで見せ場をしっかり際立たせます。",
          "title": "どんなカットを入れるべきですか？"
        },
        "photo-books-birthday-tell-story": {
          "content": "ゲストの到着からお開きまで、時系列に並べると自然にストーリーが生まれます。ワンタップで自動配置し、さらにカスタマイズも可能です。",
          "title": "ストーリー仕立てにするには？"
        },
        "photo-books-birthday-angle-focus": {
          "content": "カラーテーマやパーティーのモチーフを決めておくと、統一感のあるフォトブックに。マット加工のハードカバーがどんなテーマにもエレガントに調和します。",
          "title": "テーマやコンセプトを持つべきですか？"
        },
        "photo-books-birthday-subjects-interest": {
          "content": "パーティーゲーム、おしゃれなコーディネート、ゲスト同士の交流など、バリエーション豊かな被写体がページをめくる楽しさを生みます。Mixtilesの高品質フォトブックなら、一枚一枚の写真が主役になり、思い出を美しく残せます。",
          "title": "各ページを面白くする被写体は？"
        },
        "photo-books-birthday-how-many-photos": {
          "content": "50〜100枚がバランスの良い目安です。最大150枚まで収録可能なので、お気に入りの瞬間をすべて入れつつ、すっきりしたレイアウトを保てます。",
          "title": "何枚の写真を入れるべきですか？"
        },
        "photo-books-retirement-how-create": {
          "content": "最低24枚、最大{{max_photos}}枚の写真をアップロード。自動配置された後、自由にカスタマイズ。1ページ1枚のレイアウトですべての瞬間が輝きます。プレミアムな紙質のページとハードカバーで美しい記念品に。",
          "title": "退職記念フォトブックの作り方は？"
        },
        "photo-books-retirement-when-start-planning": {
          "content": "少なくとも1か月前から準備を始めるのがおすすめです。同僚から写真やメッセージを集めたり、レイアウトを考えたりする余裕が生まれます。Mixtilesなら途中保存もできるので、素材が揃ってからじっくり仕上げられます。",
          "title": "いつから準備を始めるべきですか？"
        },
        "photo-books-retirement-types-photos": {
          "content": "キャリアのハイライト（重要なプロジェクト、表彰、昇進）と、職場での日常的な交流や友情を捉えた写真をバランスよく入れましょう。トリミングや配置の調整で、一枚一枚がストーリーにぴったりはまる一冊に仕上がります。",
          "title": "どんな写真を入れるべきですか？"
        },
        "photo-books-retirement-coworkers-contribute": {
          "content": "ぜひ！同僚からの写真やメッセージは、フォトブックに深みと温かみを加えます。複数の視点からの思い出が集まり、Mixtilesのサイトやアプリで簡単にまとめられます。",
          "title": "同僚に写真やメッセージを寄せてもらうべきですか？"
        },
        "photo-books-retirement-humor-personal-touches": {
          "content": "ユーモアやその人らしい演出が、退職記念フォトブックを特別な一冊にします。面白いアドバイス、職場のジョーク、思い出に残ることばなどを入れてみましょう。編集機能でテキストや写真を自在に調整できるので、その人らしさをしっかり表現できます。",
          "title": "ユーモアや個性を加えるには？"
        },
        "photo-books-retirement-layout-ideas": {
          "content": "キャリアの歩みを時系列で構成するのがおすすめ。初期のキャリアから退職まで、重要な節目を追いかけるタイムラインが感動的な一冊になります。1ページ1枚のレイアウトで、それぞれの節目をしっかり見せられます。",
          "title": "レイアウトのアイデアは？"
        },
        "photo-books-retirement-photo-quality": {
          "content": "美しい仕上がりには写真の品質が重要です。600×600〜7000×7000ピクセルの解像度を推奨。基準を満たさない写真がある場合はお知らせします。",
          "title": "写真の画質はどのくらい重要ですか？"
        },
        "photo-books-retirement-meaningful-gifts": {
          "content": "退職記念フォトブックは、キャリアの歩みと人とのつながりを凝縮した心のこもったギフト。Mixtilesなら、長く大切にしていただけるプレミアムな一冊に仕上がります。",
          "title": "なぜ退職記念フォトブックは意味のあるギフトですか？"
        },
        "photo-books-fathers-day-great-gift": {
          "content": "世界にひとつだけの父の日ギフト、フォトブック。家族の思い出、旅行、節目の瞬間を一冊にまとめた特別なプレゼント。高品質な素材で長く愛される一冊に。",
          "title": "なぜフォトブックは父の日のギフトにぴったりですか？"
        },
        "photo-books-fathers-day-memories-include": {
          "content": "お父さんとの特別な瞬間を集めましょう。家族旅行、スポーツ観戦、日常のふれあい、節目の記念写真など。お父さんの個性が伝わる写真がおすすめです。1ページ1枚のレイアウトで、編集ツールを使って自由に配置できます。",
          "title": "どんな思い出を入れるべきですか？"
        },
        "photo-books-fathers-day-make-special": {
          "content": "「昔と今」をテーマにして、幼い頃から最近までの写真を時系列で並べるのもおすすめです。表紙の写真とタイトルをカスタマイズして特別な一冊に。コメントで感謝のメッセージを添えると、より心に響くギフトになります。Mixtilesなら簡単に作れます。",
          "title": "父の日フォトブックを特別な一冊にするコツは？"
        },
        "photo-books-fathers-day-involve-children": {
          "content": "お子さんに写真を選んでもらったり、メッセージを書いてもらうのも素敵。絵や手書きメッセージをスキャンして入れることもできます。家族みんなで作ることで、より思い出深い一冊に。Mixtilesで自由にデザインしましょう。",
          "title": "子どもも一緒に作れますか？"
        },
        "photo-books-fathers-day-format-recommended": {
          "content": "マット加工のハードカバーとシルクのようになめらかな質感の紙で、色鮮やかで上質な仕上がりです。{{v1}}、{{v2}}、{{v3}}の3サイズをご用意。お父さんの好みやどこに飾るかに合わせてお選びください。",
          "title": "父の日フォトブックにおすすめのサイズは？"
        },
        "photo-books-fathers-day-who-book-for": {
          "content": "父親だけでなく、おじいちゃん、義父、父親的な存在の方への贈り物にも。家族の絆を形にした一冊は、誰にとっても嬉しいギフトです。{{v1}}から{{v3}}までのサイズからお選びいただけます。",
          "title": "このフォトブックは誰向けですか？"
        },
        "photo-books-fathers-day-how-many-photos": {
          "content": "24〜{{max_photos}}枚まで収録可能。50〜80枚程度がバランスよくまとまりやすいです。",
          "title": "何枚の写真が必要ですか？"
        },
        "photo-books-fathers-day-nostalgic-photos": {
          "content": "もちろんです！懐かしい家族写真は父の日フォトブックにぴったり。最低600×600ピクセルの解像度があれば、昔の写真も美しくプリントできます。Mixtilesの高品質プリントで、懐かしい思い出がよみがえります。",
          "title": "昔の家族写真を使えますか？"
        },
        "photo-books-pet-dog-create-personalized": {
          "content": "Mixtilesならお気に入りの愛犬写真をアップロードするだけで、自動的にフォトブックに。さらに写真の並び替え、トリミングなどで自由にカスタマイズ。プレミアムな紙質のページとマット加工のハードカバーで、思い出が一生の宝物に。",
          "title": "愛犬フォトアルバムの作り方は？"
        },
        "photo-books-pet-dog-photos-include": {
          "content": "日常のしぐさ、遊んでいる瞬間、くつろいでいる姿など、愛犬の個性が伝わる写真を幅広く入れましょう。24〜{{max_photos}}枚まで収録可能です。",
          "title": "どんな写真を入れるべきですか？"
        },
        "photo-books-pet-dog-puppy-family-photos": {
          "content": "もちろんです！子犬時代の写真と家族写真を組み合わせると、愛犬の成長と家族の絆を一冊で語れる、家族の宝物になります。",
          "title": "子犬時代の写真や家族写真も入れられますか？"
        },
        "photo-books-pet-dog-choose-best-photos": {
          "content": "感動を呼ぶ高品質な写真を選びましょう。推奨解像度は600×600〜7000×7000ピクセル。編集ツールでトリミングや補正も可能です。",
          "title": "ベストな写真の選び方は？"
        },
        "photo-books-pet-dog-why-make-album": {
          "content": "愛犬との特別な絆や大切な瞬間を、永く残せる一冊です。リビングやローテーブルに置いて楽しんだり、大切な人にシェアしたりできる素敵な一冊です。",
          "title": "なぜ愛犬のフォトアルバムを作るのですか？"
        },
        "photo-books-pet-dog-templates-design-ideas": {
          "content": "Mixtilesではテンプレートではなく、ワンタップで写真が自動的にレイアウトされます。さらに自由にカスタマイズして、愛犬のユニークなストーリーを反映した一冊に仕上げましょう。",
          "title": "テンプレートやデザインのアイデアは？"
        },
        "photo-books-pet-dog-include-milestones": {
          "content": "「初めてのお散歩」「初めてのクリスマス」など、成長の節目の写真を入れると、より思い出深い一冊になります。1ページに1枚ずつ写真を入れられるので、それぞれの大切な瞬間をしっかり引き立てられます。",
          "title": "成長の節目の写真を入れるべきですか？"
        },
        "photo-books-pet-dog-gift-idea": {
          "content": "はい、愛犬家へのギフトに最適です。購入時に複数冊注文でき、友人や家族にも同じ素敵な思い出をシェアできます。",
          "title": "ペット好きの方へのギフトにできますか？"
        },
        "photo-books-anniversary-great-gift": {
          "content": "記念日フォトブックは、ふたりの歩みを一冊に凝縮した心のこもったギフト。Mixtilesなら、お気に入りの写真を厳選して一冊にまとめられます。ページをめくるたびに大切な思い出が蘇ります。",
          "title": "なぜフォトブックは記念日に最適ですか？"
        },
        "photo-books-anniversary-memories-include": {
          "content": "大切な節目と日常の瞬間をバランスよく。初めての写真、特別な旅行、思い出のお祝いなどを入れましょう。編集機能で写真を自然な流れで並べながら、ふたりだけの記念日アルバムに仕上げましょう。",
          "title": "記念日フォトブックにはどんな思い出を入れるべきですか？"
        },
        "photo-books-anniversary-how-many-photos": {
          "content": "24〜{{max_photos}}枚まで収録可能。1ページ1枚のすっきりしたレイアウトで、洗練された仕上がりに。",
          "title": "記念日フォトブックには何枚の写真が最適ですか？"
        },
        "photo-books-anniversary-everyday-candid-moments": {
          "content": "もちろんです！自然体の日常写真がふたりの関係の本質を伝えます。Mixtilesでは、すべての瞬間が大切だと考えています。",
          "title": "日常のスナップも入れていいですか？"
        },
        "photo-books-anniversary-personal-unique": {
          "content": "表紙に特別な写真を選び、テキストをカスタマイズ。写真のトリミングと配置でふたりだけのストーリーを。プレミアムな紙質のページで見た目も手触りも特別な一冊に。",
          "title": "記念日フォトブックを自分らしく特別な一冊にするには？"
        },
        "photo-books-anniversary-any-year-celebration": {
          "content": "はい、1周年でも50周年でも、どんな記念日にもぴったり。耐久性のあるマット加工のハードカバーで、年月を超えて愛される一冊に。",
          "title": "何周年の記念にも合いますか？"
        },
        "photo-books-anniversary-photo-quality": {
          "content": "鮮明なプリントには600×600〜7000×7000ピクセルの解像度を推奨。基準を満たさない写真がある場合はお知らせしますので、最適な写真をお選びください。",
          "title": "写真の推奨品質は？"
        },
        "photo-books-anniversary-tell-love-story": {
          "content": "時系列またはテーマ別に写真を配置して、ふたりの物語を語りましょう。ワンタップで簡単にアップロード・配置。長く大切にしたい記念品に仕上がります。",
          "title": "ラブストーリーを語るには？"
        },
        "photo-books-mothers-day-perfect-gift": {
          "content": "世界にひとつだけの母の日ギフト、フォトブック。大切な思い出を手に取って何度でも振り返れます。プレミアムな紙質のページとマット加工のハードカバーで、お母さんがずっと大切にしたくなる一冊に。",
          "title": "なぜフォトブックは母の日に最適ですか？"
        },
        "photo-books-mothers-day-memories-include": {
          "content": "家族の集まり、旅行のハイライト、節目のイベントなどを入れましょう。お母さんとの絆を伝える写真を集めて、思い出にスポットライトを当てましょう。Mixtilesの編集機能で、写真を思い通りに配置できます。",
          "title": "どんな思い出を入れるべきですか？"
        },
        "photo-books-mothers-day-personalize-book": {
          "content": "Mixtilesなら簡単に自分らしく仕上げられます。各ページにコメントや心のこもったメッセージを添えて、表紙の写真とテキストも自由に調整できます。世界にひとつだけの贈り物に仕上げましょう。",
          "title": "お母さんにぴったりの一冊にするには？"
        },
        "photo-books-mothers-day-creative-themes": {
          "content": "「この一年の振り返り」「世代を超えた愛」「お母さんのお気に入りの瞬間」など、テーマを決めるとストーリーがまとまります。1ページ1枚のレイアウトで自動配置も可能です。",
          "title": "母の日フォトブックに合うテーマのアイデアは？"
        },
        "photo-books-mothers-day-shared-activities": {
          "content": "もちろんです！一緒に過ごした時間の写真は、親子の絆を表現するのに欠かせません。鮮やかな色彩で思い出が生き生きと蘇ります。",
          "title": "一緒に過ごした時間の写真を入れるべきですか？"
        },
        "photo-books-mothers-day-how-far-back": {
          "content": "特に決まりはありません。最近の写真と昔の写真を組み合わせて、親子の歩みを振り返りましょう。最大{{max_photos}}枚まで収録可能です。",
          "title": "どのくらい昔の写真まで入れていいですか？"
        },
        "photo-books-mothers-day-quotes-messages": {
          "content": "はい、心のこもったメッセージを添えると、より感動的な一冊に仕上がります。お母さんの好きなことばや、ふたりの思い出のひとことを入れてみましょう。Mixtilesのサイトやアプリで簡単にテキストを追加できます。",
          "title": "母の日フォトブックにメッセージを入れられますか？"
        },
        "photo-books-mothers-day-creation-steps": {
          "content": "ウェブサイトまたはアプリで最低24枚の写真をアップロード。ワンタップで自動配置された後、自由にカスタマイズ。サポートチームがメールやチャットでお手伝いします。",
          "title": "母の日フォトブックの作り方は？"
        },
        "photo-books-deals-current-available": {
          "content": "Mixtilesでは定期的にフォトブックのお得なキャンペーンを実施しています。多くの場合15〜20%OFFで、季節のイベントや特別キャンペーン時に提供されます。プロモーションが有効な場合、カートに自動適用されるのでコード入力は不要です。ワンタップ作成機能でお気に入りの写真をアップロードするだけで、すぐに注文できるフォトブックが完成します。",
          "title": "現在のフォトブックキャンペーンは？"
        },
        "photo-books-deals-apply-promo-code": {
          "content": "多くのキャンペーンは自動適用ですが、メールやSNSでプロモコードをお受け取りの場合は、メニューアイコン（☰）→プロモコード→プロモコードを追加でコードを入力してください。適用後、カートに割引が反映されます。コードが使えない場合は、有効期限や他のプロモーションとの併用制限をご確認ください。",
          "title": "プロモコードの使い方は？"
        },
        "photo-books-deals-combine-multiple": {
          "content": "1回のご注文につきプロモーションは1つまでとなります。複数のコードをお持ちの場合は、次回のご注文にお使いください。フォトブックと同じく、シンプルでわかりやすい仕組みです。",
          "title": "複数のキャンペーンを併用できますか？"
        },
        "photo-books-deals-bigger-orders": {
          "content": "Mixtilesのフォトブックはページ数に関わらず固定価格です。写真を増やしても追加料金はかかりません。シンプルで透明な価格設定のため、追加のボリューム割引は設けていません。",
          "title": "大量注文でさらにお得になりますか？"
        },
        "photo-books-deals-stay-updated": {
          "content": "最新のキャンペーン情報をいち早く受け取るには、メール登録やInstagram・Facebookのフォローがおすすめです。限定プロモーションへの先行アクセスもご案内しています。",
          "title": "キャンペーン情報を受け取るには？"
        },
        "photo-books-christmas-why-make": {
          "content": "クリスマスフォトブックで、クリスマスシーズンの温かい思い出を形に。ツリーの飾り付けから家族で囲む食卓まで、クリスマスの喜びを一冊にまとめた、ずっと手元に置きたい一冊が作れます。",
          "title": "クリスマスフォトブックを作る理由は？"
        },
        "photo-books-christmas-photos-include": {
          "content": "ツリーの飾り付け、プレゼント開封、家族で囲む食卓など、クリスマスらしい瞬間を集めましょう。プレミアムな紙質のページで色鮮やかに仕上がります。",
          "title": "クリスマスフォトブックにはどんな写真を入れるべきですか？"
        },
        "photo-books-christmas-theme-book": {
          "content": "「ウィンターワンダーランド」（雪景色やあたたかい室内）や「おうちクリスマス」（家族のほっこり写真）など、テーマを決めると統一感が出ます。Mixtilesなら写真の配置もテーマに合わせて自由に調整できます。",
          "title": "クリスマスフォトブックのテーマの付け方は？"
        },
        "photo-books-christmas-decorations-captions": {
          "content": "Mixtilesの編集ツールで、コメントやクリスマスのデコレーションを追加して、より特別な一冊に仕上げられます。",
          "title": "クリスマスフォトブックにデコレーションやコメントを追加できますか？"
        },
        "photo-books-christmas-snowy-outdoor-photos": {
          "content": "もちろんです！雪景色や冬のアウトドアの写真はバリエーションを豊かにします。1ページ1枚のレイアウトで細部まで美しく見せます。",
          "title": "雪景色やアウトドアの写真も入れられますか？"
        },
        "photo-books-christmas-creative-ideas": {
          "content": "ステッカーやメッセージを添えて、クリスマスらしい一冊に仕上げましょう。編集機能を使えば、クリスマス気分が伝わる、あなただけの一冊にできます。",
          "title": "クリスマスフォトブックのアイデアは？"
        },
        "photo-books-christmas-meaningful-gift": {
          "content": "自分らしく仕上げた思い出の一冊は、何年も大切にしてもらえる心のこもったギフトです。マット加工のハードカバーで高級感もあり、大切な人との思い出を分かち合えます。",
          "title": "クリスマスフォトブックは心のこもったギフトになりますか？"
        },
        "photo-books-christmas-creation-steps": {
          "content": "テーマを決め、お気に入りのクリスマスの写真を選びましょう。最低24枚をウェブサイトやアプリからアップロードすると、ワンタップでフォトブックが完成します。さらに自由に調整して、あなただけのクリスマスの一冊に仕上げられます。",
          "title": "クリスマスフォトブックの作り方は？"
        },
        "photo-books-12x12-sizes-formats": {
          "content": "Mixtilesでは{{size_display}}を含む3つのサイズをご用意。{{size_display}}は大胆で目を引くディスプレイに最適。マット加工のハードカバーで耐久性がありながら高級感のある仕上がりです。",
          "title": "{{size_display}}フォトブックのサイズとフォーマットは？"
        },
        "photo-books-12x12-pages-contain": {
          "content": "{{size_display}}フォトブックは24〜{{max_photos}}ページで作成できます。1ページに1枚ずつ写真を入れられるので、一つひとつの大切な瞬間をしっかり引き立てながら、特別な日の思い出をコンパクトにまとめた一冊にも、たくさんの写真を収めた写真集にも仕上げられます。",
          "title": "{{size_display}}フォトブックは何ページまで作れますか？"
        },
        "photo-books-12x12-cover-materials": {
          "content": "{{size_display}}フォトブックは、マット加工のハードカバーで耐久性と上品さを兼ね備えています。内側にはシルクのようになめらかな質感の紙を使用し、写真を鮮やかに美しく見せます。",
          "title": "{{size_display}}フォトブックのカバー素材は？"
        },
        "photo-books-12x12-lay-flat-hardcover": {
          "content": "ハードカバー仕様で、思い出をしっかり保護。フラットに開くタイプではありませんが、美しいプレゼンテーションで長くお楽しみいただけます。",
          "title": "{{size_display}}フォトブックはハードカバーですか？"
        },
        "photo-books-12x12-good-for": {
          "content": "リビングやローテーブルに置いて楽しむのに最適です。大きなフォーマットで写真の細部まで美しく見せ、印象的なストーリーを語ります。",
          "title": "{{size_display}}フォトブックの活用法は？"
        },
        "photo-books-12x12-compare-smaller": {
          "content": "小さいサイズと比べて、より広いキャンバスで写真を楽しめます。細部まで鮮明に、充実したストーリーテリングが可能です。",
          "title": "{{size_display}}フォトブックと小さいサイズの違いは？"
        },
        "photo-books-12x12-price-range": {
          "content": "サイズとプレミアム素材により、小さいサイズよりも価格は高くなりますが、印象的な仕上がりは十分に価値があります。",
          "title": "{{size_display}}フォトブックの価格帯は？"
        },
        "photo-books-12x12-professional-portfolio": {
          "content": "はい。{{size_display}}フォトブックは、作品集やポートフォリオにも適しています。上質な印刷と自由に調整できるレイアウトで、作品や大切なプロジェクトを印象的に見せられます。",
          "title": "{{size_display}}フォトブックは作品集やポートフォリオにも使えますか？"
        },
        "photo-books-8x8-what-makes-special": {
          "content": "{{size_display}}フォトブックは、コンパクトで飾りやすいスクエア型のフォトブックです。Mixtilesのマット加工のハードカバーとシルクのようになめらかな質感の紙で、小さくても品質に妥協しない一冊に仕上がります。ページをめくるたびに思い出がよみがえります。",
          "title": "{{size_display}}フォトブックの特徴は？"
        },
        "photo-books-8x8-mix-portrait-landscape": {
          "content": "はい、縦向きと横向きの写真を自由に組み合わせ可能。ズーム、トリミング、配置の調整も簡単。1ページ1枚ですべての写真が引き立ちます。",
          "title": "{{size_display}}フォトブックで縦向きと横向きの写真を混ぜられますか？"
        },
        "photo-books-8x8-cover-options": {
          "content": "プレミアムなマット加工のハードカバーをご用意しています。表紙の写真を選び、テキストも編集できるので、自分らしい一冊に仕上げられます。",
          "title": "{{size_display}}フォトブックのカバーの種類は？"
        },
        "photo-books-8x8-good-occasions": {
          "content": "家族の集まり、旅行、ウェディング、記念日など、さまざまな場面に最適です。コンパクトなサイズなので、思い出を残す記念品にも、贈り物にもぴったり。大切な瞬間を手軽にまとめて、家族や大切な人とも共有しやすい一冊です。",
          "title": "{{size_display}}フォトブックはどんな場面におすすめですか？"
        },
        "photo-books-8x8-pages-have": {
          "content": "Mixtilesの{{size_display}}フォトブックは24〜{{max_photos}}ページで作成できます。写真が少ない場合も多い場合も、さまざまな思い出をお好みの分量で収められるので、思い通りのストーリーを一冊にまとめられます。",
          "title": "{{size_display}}フォトブックは何ページまで作れますか？"
        },
        "photo-books-8x8-square-format-display": {
          "content": "はい、スクエアフォーマットなので、ローテーブルや棚、デスクなど、さまざまな場所に飾りやすいサイズです。",
          "title": "{{size_display}}はスクエアフォーマットで飾りやすいですか？"
        },
        "photo-books-8x8-templates-styles": {
          "content": "Mixtilesならワンタップで写真が自動的にまとまりのあるレイアウトに。複数のテンプレートはありませんが、写真の順番やトリミングを自由にカスタマイズできます。",
          "title": "{{size_display}}フォトブックのテンプレートやスタイルの種類は？"
        },
        "photo-books-8x8-why-choose": {
          "content": "持ち運びやすさと飾りやすさの完璧なバランス。写真を美しく見せつつ、コンパクトに収まります。あらゆるシーンに馴染む万能サイズです。",
          "title": "なぜ{{size_display}}を選ぶのですか？"
        },
        "photo-books-recipe-what-is": {
          "content": "レシピフォトブックは、お気に入りのレシピと美しい料理写真をまとめた一冊です。レシピ本のように使えるだけでなく、料理の思い出や歩みを視覚的にも楽しめる一冊として残せます。Mixtilesならプレミアムな紙質のページで、料理写真が一段と美しく映えます。",
          "title": "レシピフォトブックとは？どのように使いますか？"
        },
        "photo-books-recipe-old-family-recipes": {
          "content": "手書きのレシピはスキャンして画像としてアップロードできます。完成した料理の写真や、一緒に料理する家族の写真と並べて配置すれば、昔と今をつなぐレシピフォトブックに仕上がります。",
          "title": "昔の家族のレシピを入れるには？"
        },
        "photo-books-recipe-themes": {
          "content": "季節のレシピ、デザート特集、節約レシピなど、テーマは無限大です。Mixtilesのフォトブックが美しいキャンバスになり、市販のレシピ本では実現できないオリジナルな一冊を作れます。",
          "title": "レシピフォトブックにはどんなテーマが合いますか？"
        },
        "photo-books-recipe-organize": {
          "content": "時系列、カテゴリ別（前菜、メイン、デザート）など、お好みの方法で整理。Mixtilesのサイトやアプリで簡単にページの並べ替えができます。",
          "title": "レシピフォトブックでレシピを整理するには？"
        },
        "photo-books-recipe-layout-details": {
          "content": "各レシピには、タイトル、材料リスト、手順、写真を含めましょう。1ページ1枚のレイアウトで各料理の美しさが際立ちます。個人的なメモやコツも添えられます。",
          "title": "各レシピに必要なレイアウト要素は？"
        },
        "photo-books-recipe-cooking-process-photos": {
          "content": "もちろんです！調理過程や完成品の写真を入れると、ストーリー性が増します。シルクのようになめらかな質感の上質な紙で料理写真が色鮮やかに再現され、見て楽しいレシピフォトブックに仕上がります。",
          "title": "レシピフォトブックに調理過程の写真も入れられますか？"
        },
        "photo-books-recipe-family-heirloom": {
          "content": "はい、レシピフォトブックは家族の宝物として世代を超えて受け継げます。マット加工のハードカバーで耐久性も抜群。家族の味と思い出を永く残せます。",
          "title": "レシピフォトブックは家族の宝物として残せますか？"
        },
        "photo-books-recipe-make-engaging": {
          "content": "レシピに個人的なメモ、エピソード、ちょっとしたコツを添えましょう。各料理の背景にあるストーリーが加わり、Mixtilesならではの特別な一冊に仕上がります。",
          "title": "魅力的なレシピフォトブックにするコツは？"
        },
        "shipping-location": {
          "content": "はい、世界中のほとんどの国へ配送可能です！",
          "title": "海外配送はできますか？"
        },
        "shipping-time": {
          "content": "通常約1週間でお届けします。一部の国ではお急ぎ便もご利用いただけます。ご注文後、追跡番号をお知らせします。",
          "title": "配送にはどのくらいかかりますか？"
        },
        "title": "よくある質問",
        "walls": {
          "content": "いいえ、壁を傷つけません。",
          "title": "壁に傷がつきますか？"
        }
      },
      "fullscreen_title": "スマホから、\n美術館品質のプリントを",
      "fullscreen_title_desktop": "美術館品質のプリント",
      "made_in_canada": "カナダ製",
      "main_button_cta": "商品を見る",
      "photo_wall": {
        "subtitle": "お部屋にぴったりのスタイルをお選びください",
        "title": "数タップで\nフォトウォールを作成"
      },
      "secondary_title_1": "ハンマーも釘も、\nいらない",
      "secondary_title_1_desktop": "剥がして、ピタッと貼るだけ",
      "secondary_title_2": "調整も差し替えも、\n自由に",
      "secondary_title_3": "壁を傷つけない",
      "meet_magnetic_hanging": "マグネット式で、\nかんたん設置",
      "seen-on": "掲載メディア",
      "seen-on-desktop": "掲載メディア",
      "simple_price": {
        "subtitle": "わかりやすい料金設定で、隠れた費用はありません。送料も無料です。",
        "title": "何ページでも、お値段はそのまま"
      },
      "simple_price_tiers": {
        "from_label": "最低価格",
        "subtitle": "サイズとページ数に応じたわかりやすい料金設定で、送料は無料です。",
        "title": "シンプルな料金、追加費用なし"
      },
      "title": "いつもの壁が、\nギャラリーに変わる",
      "try_now": {
        "continue": "ブックの続きを作る",
        "subtitle": "数タップでデザイン、3Dプレビューで仕上がりをチェック",
        "title": "かんたん\nフォトブック作成",
        "design_subtitle": "数タップで旅の思い出を美しいコーヒーテーブルブックに",
        "design_title": "かんたん\n旅のフォトブック作成",
        "life_events_subtitle": "数タップで、人生の大切な瞬間を美しいコーヒーテーブルブックに",
        "life_events_title": "人生の節目に、\n美しい一冊を",
        "create_now": "今すぐ作成"
      },
      "email_signup": {
        "title": "お得な情報やデコレーションのアイデアをいち早くお届け",
        "email_label": "メールアドレス",
        "terms_text": "クリックすると利用規約とプライバシーポリシーに同意したことになります",
        "success_message": "ご登録ありがとうございます"
      }
    },
    "login": {
      "last_used": "前回使用",
      "continue_with": "で続ける",
      "create_account_error": "アカウント作成中にエラーが発生しました",
      "error_dialog": {
        "login_unsuccessful_message": "もう一度お試しいただくか、\nサポートまでお問い合わせください",
        "login_unsuccessful_title": "ログインに失敗しました",
        "incorrect_email_or_code_message": "入力したメールアドレスまたはコードが正しくありません。メールアドレスまたはコードをもう一度入力してお試しください。",
        "incorrect_email_or_code_title": "メールアドレスまたはコードが正しくありません。",
        "too_many_incorrect_attempts_message": "アカウントの制限を解除するため、メールをご確認ください。",
        "too_many_incorrect_attempts_title": "試行回数が上限に達しました。"
      },
      "email_capture_placeholder": "メールアドレスを入力",
      "email_code": {
        "code_sent": "コードをメールで送信しました",
        "code_sent_detailed": "{{email}} にコードを送信しました",
        "resend_code": "コードを再送信",
        "resend_code_countdown": "{{seconds}}秒後に再送できます",
        "enter_code": "コードを入力"
      },
      "login": "ログイン",
      "login_message": "{{v1}}すると、作成内容の保存や注文状況の確認ができます",
      "login_or_sign_up": "ログイン / 新規登録",
      "login_successfully": "ログインしました！",
      "no_email_error": "アカウント作成にはメールアドレスの提供が必要です。",
      "register_successfully": "ようこそ！登録が完了しました",
      "restored_photo": "保存済みの写真を復元しました",
      "restored_photos": "保存済みの写真を復元しました",
      "restricted": {
        "title": "注文を確認するには\nログインしてください"
      },
      "sign_out": "ログアウト",
      "sign_up": "新規登録",
      "start_your_design_journey": "デザインをはじめよう",
      "terms_of_use": {
        "and": "および",
        "privacy_policy": "プライバシーポリシー",
        "terms_of_use": "利用規約",
        "terms_of_use_intro": "登録すると以下に同意したことになります："
      },
      "verify_email_dialog": {
        "button": "あとで確認する",
        "content": "ご本人確認と過去のご注文の表示のため、{{v1}} に確認メールを送信しました。",
        "title": "メールをご確認ください"
      }
    },
    "logout": {
      "signed_out_successfully": "ログアウトしました",
      "signed_out_successfully_subtitle": "再度ログインすると、保存済みの写真を確認できます"
    },
    "multi_product_homepage": {
      "photo_walls_title": "フォトウォール",
      "photo_walls_subtitle": "お気に入りの写真を素敵なウォールアートに",
      "photo_books_subtitle": "かんたん操作でフォトブックを作成",
      "pet_portraits_subtitle": "ペットの写真を楽しいアートに",
      "shop_now": "今すぐ購入",
      "continue_designing": "デザインを続ける",
      "explore_now": "詳しく見る",
      "download": "ダウンロード",
      "app_title": "新しいMixtilesアプリ",
      "app_subtitle": "お気に入りの瞬間が、そのままフォトアイテムに。",
      "app_store_badge": "App Storeからダウンロード",
      "get_app_title": "新しいMixtilesアプリを入手",
      "new_products_title": "新商品をチェック",
      "desktop_new_products_title": "商品",
      "new_products": {
        "caricature": "カリカチュア",
        "the_studio": "スタジオ"
      },
      "best_place_title": "写真をプリントするならMixtiles",
      "stats": {
        "rating_caption": "15万6千件以上のレビュー",
        "customers_caption": "ご満足いただいたお客様"
      },
      "desktop_stats": {
        "photos_printed_caption": "印刷された写真"
      }
    },
    "my_orders": {
      "active_orders": "進行中の注文",
      "completed_orders": "完了した注文",
      "no_orders_button": "写真を選ぶ",
      "no_orders_title": "まだ注文がありません。",
      "resend_email": "メールを再送信",
      "verify_email": "メールアドレスを確認"
    },
    "new_email_capture": {
      "a_box_of_mixtiles": {
        "subtitle": "自分が写真を選ぶ",
        "title": "Mixtilesセット",
        "tiles_or_book": "タイルまたはフォトブック"
      },
      "agree_to_emails": "お知らせやキャンペーン情報の受信に同意する",
      "agree_to_emails_sign_now": "限定オファーや暮らしを彩るアイデア、\n新商品情報を受け取る",
      "attribution": {
        "channels": {
          "email": "メール",
          "facebook": "Facebook",
          "flyer": "チラシ",
          "friend": "知人・友人",
          "game": "スマホゲーム",
          "google": "Google",
          "instagram": "Instagram",
          "other": "その他",
          "pinterest": "Pinterest",
          "podcast": "ポッドキャスト",
          "airport": "空港",
          "shorts": "ショート動画",
          "snapchat": "Snapchat",
          "stacey_solomon": "Stacey Solomon",
          "rebecca_judd": "Rebecca Judd",
          "tammin_sursok": "Tammin Sursok",
          "tia_mowry": "Tia Mowry",
          "tiktok": "TikTok",
          "tv": "テレビ",
          "twitter": "X",
          "youtube": "YouTube"
        },
        "help_us_improve": "サービス向上にご協力ください！",
        "sub_options": {
          "influencer": "インフルエンサー",
          "not_sure": "覚えていない",
          "paid_ad": "広告"
        },
        "title": "Mixtilesを何で\n知りましたか？"
      },
      "continue": "次へ",
      "disagree_to_emails": {
        "emphasized": "希望しない",
        "text": "当社からのキャンペーンの受信を{{emphasized}}場合はチェックしてください"
      },
      "email_placeholder": "メールアドレス",
      "for_gift": "大切な人へ",
      "for_gift_subtitle": "贈り物として購入する",
      "for_me": "自分用",
      "for_me_subtitle": "お部屋に飾る",
      "gift_card": {
        "subtitle": "相手が写真を選ぶ",
        "title": "ギフトカード"
      },
      "gift_question": "何を贈りますか？",
      "intro": {
        "title": "Mixtilesを\nはじめましょう"
      },
      "lets_create": "素敵なギフトを\n作りましょう",
      "name_placeholder": "お名前",
      "privacy_disclaimer": "続行すると、{{v1}}および{{v2}}に\n同意したことになります",
      "sms_step_label": "電話番号を入力",
      "sms_step_title": "お得な情報をスマホでお届け",
      "sms_privacy_disclaimer": "電話番号をご入力いただくと、マーケティングメッセージの受信に同意したことになります。同意は購入の条件ではありません。通信料が発生する場合があります。配信停止はSTOPと返信してください。{{v1}}および{{v2}}をご確認ください",
      "sms_privacy_disclaimer_consent": "電話番号をご入力いただくと、プライバシーポリシーに基づきマーケティングメッセージの受信に同意したことになります。配信停止はSTOPと返信してください",
      "title": "こんにちは、\n{{v1}}さん！",
      "title_no_name": "こんにちは！",
      "who_for": "どなた用ですか？"
    },
    "order": {
      "canada_tariff_notice_bag": "キャンバスとフォトブックは関税がかかりません",
      "canada_tariff_notice_tiles": "キャンバスは関税がかかりません",
      "add_photos": "写真を追加",
      "add_photos_count": "{{v1}}枚追加",
      "add_photos_single": "1枚追加",
      "add_to_bag": "バッグに追加",
      "art": "アート",
      "art_orientation_warning": {
        "checkout": {
          "label": {
            "singular": "アートは縦向きが最適です。"
          }
        }
      },
      "checkout": {
        "add_address": "住所を追加",
        "add_gift_note": "ギフトメッセージを追加",
        "add_gift_note_options": {
          "close": "閉じる",
          "description": "メッセージをお荷物に同封します（納品書は含まれません）",
          "edit_note": "メッセージを編集・削除",
          "edit_options": {
            "dismiss": "閉じる",
            "edit": "テキストを編集",
            "remove": "ギフトメッセージを削除"
          },
          "header": "ギフトメッセージを追加",
          "placeholder": "いつもありがとう。素敵な思い出を飾ってね。",
          "start_writing": "メッセージを入力"
        },
        "add_payment": "お支払い方法を追加",
        "add_payment_options": {
          "credit_card_ends_with": "下4桁 {{v1}}",
          "paying_with": "{{v1}}でお支払い"
        },
        "are_you_sure": "よろしいですか？",
        "change_info": "変更",
        "confirm_button_text_gdpr": "確認して支払う",
        "confirm_button_text_non_gdpr": "注文を確定する",
        "tokushoho_disclaimer": "返品・キャンセル条件／特定商取引法に基づく表記",
        "gift_card_available_credits": "残高 {{v1}}",
        "gift_card_credits": "ギフトカードクレジット",
        "gift_card_remove_title": "ギフトカードを削除してもよろしいですか？",
        "gift_note_added": "ギフトメッセージを追加しました",
        "minimum_order_fee": {
          "description": [
            "最低注文金額は{{v1}}です。",
            "差額分を加算させていただきます。"
          ],
          "title": "最低注文金額差額"
        },
        "no_go_back": "いいえ、戻る",
        "payment_errors": {
          "add_new_card": "新しいカードを追加",
          "authentication_failed_text": "カードの認証に失敗しました。新しいカードを追加してもう一度お試しください。",
          "authentication_failed_title": "認証に失敗しました",
          "card_declined_text": "カードが承認されませんでした。別のカードでお試しください。",
          "card_declined_text_1": "カードが承認されませんでした。カード情報をご確認ください。",
          "card_declined_text_2": "情報に間違いがない場合は、カード会社にお問い合わせのうえ、もう一度お試しください。",
          "card_declined_title_2": "カードが承認されませんでした",
          "charge_failed_text": "お支払いの処理に失敗しました。新しいクレジットカードを追加してもう一度お試しください。",
          "charge_failed_title": "お支払いに失敗しました",
          "incomplete_photo_wall": {
            "missing_photos_plural": "フォトウォールにあと{{v1}}枚の写真が必要です",
            "missing_photos_singular": "フォトウォールにあと1枚の写真が必要です"
          },
          "invalid_email_text": "ご注文を完了できるよう、メールアドレスを再度ご入力ください。",
          "invalid_email_title": "メールアドレスをご入力ください",
          "no_charge_text": "お支払いは発生していませんのでご安心ください",
          "no_tiles_selected": "タイルが選択されていません",
          "oops_order_failed": "ご注文に失敗しました",
          "order_price_calculation": {
            "subtitle": "ページを更新してください。写真は保存されていますのでご安心ください。",
            "title": [
              "申し訳ございません。",
              "価格の計算中にエラーが発生しました"
            ]
          },
          "order_error_text": "ご注文を完了できませんでした。もう一度お試しいただくか、サポートまでお問い合わせください。",
          "order_error_title": "ご注文に失敗しました",
          "payment_error_text": "お支払いエラーにより、ご注文を完了できませんでした。もう一度お試しいただくか、サポートまでお問い合わせください。",
          "payment_error_title": "お支払いに失敗しました",
          "uploads_failed_text": "一部の写真の処理に問題がありました。もう一度アップロードしてください。"
        },
        "payment_methods": "お支払い方法",
        "payment_summary_rows": {
          "add_many_more_to_get_discount": "あと{{v1}}枚追加で{{v2}}%OFF",
          "add_more_to": {
            "get_more_many": "あと{{v1}}枚追加で{{v2}}枚無料！",
            "get_more_one": "あと{{v1}}枚追加で1枚無料！"
          },
          "add_one_more_to_get_discount": "あと1枚追加で{{v1}}%OFF",
          "add_one_to": {
            "get_more_many": "あと1枚追加で{{v2}}枚無料！",
            "get_more_one": "あと1枚追加で1枚無料！"
          },
          "are_free": "うち{{v1}}枚は無料",
          "base_price_many": "{{v1}}枚、1枚あたり{{v2}}",
          "bundle_action": {
            "add_another_many": "あと{{v1}}枚追加でさらにお得！",
            "add_another_one": "あと1枚追加でさらにお得！",
            "add_many": "あと{{v1}}枚追加でお得に！",
            "add_many_short": "あと{{v1}}枚追加でお得に！",
            "add_one": "あと1枚追加でお得に！",
            "add_one_short": "あと1枚追加でお得に！",
            "get_next_bundle": "{{v1}}枚なら{{v2}}",
            "perfect": "{{v1}}お得になりました！"
          },
          "bundle_change_to_size": "プロモコードを使うには{{v1}}に変更してください",
          "buy_over_percent_off_orders": "{{v1}}%OFF",
          "buy_over_percent_off_orders_over_price": "{{v2}}以上のご注文で{{v1}}%OFF",
          "buy_over_price_applied": "{{v1}}%OFF適用中！",
          "buy_over_price_applied_saved": "{{v1}}お得に！",
          "discount_percentage_literal": "{{v1}}%OFF適用中",
          "buy_over_price_buy_more": "あと{{v1}}で割引適用",
          "buy_over_price_buy_more_short": "あと{{v1}}で割引適用",
          "buy_over_tier": "{{v2}}以上で{{v1}}%OFF",
          "buy_over_tiers_pair": "{{v1}}・{{v2}}",
          "buy_x_get_y": "{{v1}}枚購入で{{v2}}枚",
          "buy_x_get_y_action": {
            "get_more_many": "あと{{v1}}枚の無料タイルを追加できます",
            "get_more_one": "あと1枚の無料タイルを追加できます",
            "saved": "{{v1}}お得になりました！",
            "yay_get_many": "次の{{v1}}枚が無料です！",
            "yay_get_one": "次の1枚が無料です！"
          },
          "can_add_free_tiles": "{{v1}}枚の無料タイルを追加できます！",
          "can_add_one_free_tile": "1枚の無料タイルを追加できます！",
          "canvas_tile": "キャンバスタイル 1枚",
          "canvas_tiles": "キャンバスタイル {{v1}}枚",
          "color_tiles": "{{color}} タイル {{v1}}枚",
          "creditUsed": "クレジット",
          "delivery_by": "お届け予定日",
          "discount": "割引",
          "discount_off_over_price": "{{v2}}以上で{{v1}}%OFF",
          "discount_off_over_price_short": "{{v2}}以上で{{v1}}%OFF",
          "discount_percentage": "{{v1}}%OFF",
          "discount_percentage_automatic": "フォトブック{{v1}}%OFF",
          "discounts_applied": "{{v1}} 適用済み",
          "eligible_free_shipping": "送料無料対象",
          "eligible_free_shipping_over": "{{v1}}以上のご注文で送料無料",
          "free": "無料",
          "free_shipping": "送料無料",
          "free_shipping_over": "{{v1}}以上で送料無料",
          "free_tiles_many": "{{v1}}枚無料",
          "free_tiles_single": "1枚無料",
          "import_fee": "輸入手数料",
          "international_taxes": "現地税",
          "is_free": "うち1枚は無料",
          "all_free": "無料",
          "many_tiles": "{{v1}}枚",
          "many_books": "{{v1}}冊、{{v2}}",
          "mixed_frames": "ミックスフレーム",
          "mixed_sizes_and_frames": "ミックスサイズ＆フレーム",
          "more_tiles_many": "あと{{v1}}枚",
          "more_tiles_one": "あと1枚",
          "more_tiles_with_each_price": "あと{{v1}}枚、1枚あたり{{v2}}",
          "one_color_tile": "{{color}} タイル 1枚",
          "one_tile": "1枚",
          "photo_book_description_plural": "フォトブック（{{v1}}ページ）",
          "photo_book_description_singular": "フォトブック（{{v1}}ページ）",
          "sales_tax": "消費税",
          "select_more_tiles_many": "あと{{v1}}枚選んでください",
          "select_more_tiles_one": "あと1枚選んでください",
          "select_some_tiles": "タイルを追加してください",
          "shipping": "送料",
          "subtotal": "小計",
          "tax": "税",
          "tiles_count": "{{v1}}枚",
          "tiles_size_many": "{{v1}}枚 {{v2}}",
          "total": "合計",
          "wall_sign": "壁掛けプレート",
          "wall_signs": "壁掛けプレート",
          "wide_frame_tile": "{{color}} ワイドフレームタイル 1枚",
          "wide_frame_tiles": "{{color}} ワイドフレームタイル {{v1}}枚",
          "will_be_free_many": "{{v1}}枚が無料になります！",
          "will_be_free_one": "1枚が無料になります！"
        },
        "promo": {
          "cancel": "プロモコードを取り消す",
          "free_tiles": "無料タイル",
          "free_books": "無料ブック",
          "title": "プロモ",
          "yes_remove": "はい、コードを削除"
        },
        "shipping_options": {
          "calculating_delivery_date": "お届け予定日を計算中...",
          "delivery_by": "{{v1}}までにお届け",
          "estimated_delivery": "お届け予定 {{v1}}",
          "express_new_version": "お急ぎ便 - {{v1}}",
          "express_name": "お急ぎ便",
          "priority": "優先配送 - {{v1}}",
          "priority_name": "優先配送",
          "standard": "通常配送"
        }
      },
      "add_product": "商品を追加",
      "cart_title": "マイバッグ",
      "cart_volume_discount": "ボリュームディスカウント",
      "cart_add_promo": "プロモコードを追加",
      "cart_change_promo": "プロモ変更",
      "cart_free_shipping_applied": "送料無料が適用されました",
      "cart_bag": "バッグ",
      "empty_bag_title": "バッグは空です",
      "empty_bag_cta": "商品を見る",
      "cart_edit": "編集",
      "cart_header": {
        "photo_book": "フォトブック",
        "tiles_one": "タイル1枚",
        "tiles_other": "タイル{{count}}枚"
      },
      "cart_summary": {
        "tiles_one": "タイル{{count}}枚",
        "tiles_other": "タイル{{count}}枚",
        "wall_signs_one": "壁掛けプレート{{count}}枚",
        "wall_signs_other": "壁掛けプレート{{count}}枚",
        "with_size": "{{item}}、{{size}}",
        "frame_breakdown_row_one": "{{frame}}タイル{{count}}枚、{{size}}",
        "frame_breakdown_row_many": "{{frame}}タイル{{count}}枚、{{size}}",
        "canvas_breakdown_row": "{{frame}}{{count}}枚、{{size}}",
        "frame_tiles_one": "{{frame}}タイル{{count}}枚",
        "frame_tiles_many": "{{frame}}タイル{{count}}枚",
        "canvas_tiles": "{{frame}}{{count}}枚",
        "combined_no_size": "{{tiles}}と{{signs}}",
        "mixed_sizes_lower": "サイズミックス",
        "mixed_frames": "フレームミックス",
        "photo_book": "フォトブック、{{size}}",
        "book_with_pages": "ブック、{{size}}、{{pageCount}}ページ"
      },
      "remove_item_popup": {
        "title": "本当に削除しますか？",
        "tiles": "作成したタイルが削除されます",
        "photo_book": "作成したフォトブックが削除されます",
        "delete": "削除"
      },
      "checkout_button_text": "ご購入手続きへ",
      "choose_from_phone": "スマホから選ぶ",
      "done": {
        "confirmation_email": "まもなく確認メールが届きます",
        "delivery_time": "{{v1}}までにお届け予定です",
        "next": "次へ",
        "please_hold": "少々お待ちください。ご注文の処理を完了しています。",
        "will_receive_email": "確認メールを下記アドレスにお送りします",
        "woohoo": "ご注文ありがとうございます！"
      },
      "faces_cropped_warning": {
        "cart_cta": "確認して修正",
        "cart_label": "顔が切れています。",
        "cta": {
          "change_size": "サイズを変更",
          "crop": "トリミングを修正"
        },
        "label": "一部の顔がトリミングされています",
        "notification": {
          "change_size": {
            "cta": "元に戻す",
            "title": "タイルを{{size}}に変更しました"
          },
          "crop": {
            "cta": "元に戻す",
            "title": "タイルのトリミングを変更しました"
          }
        }
      },
      "filters": {
        "b_n_w": "モノクロ",
        "b_n_w2": "モノクロ2",
        "dramatic": "ドラマチック",
        "noir": "ノワール",
        "none": "なし",
        "original": "オリジナル",
        "painting": "絵画",
        "painting2": "絵画2",
        "pencil": "鉛筆",
        "pencil2": "鉛筆2",
        "silver": "シルバー",
        "sketch": "スケッチ",
        "sketch2": "スケッチ2",
        "vivid": "鮮やか",
        "vivid2": "鮮やか2",
        "winter": "冬"
      },
      "frame_colors": {
        "black": "ブラック",
        "none": "フレームなし",
        "red_ash_wood": "濃木目",
        "white": "ホワイト",
        "wood": "オーク"
      },
      "frame_presets": {
        "earthy_blend": "アース",
        "classic_blend": "クラシック",
        "harmony_mix": "ハーモニー"
      },
      "import_from_google_photos": "Googleフォトから取り込む",
      "incomplete_collage_warning": {
        "label": "コラージュの写真が足りません。"
      },
      "ai_tile_generating_warning": {
        "label": "新しいスタイルを作成中です。",
        "cta": "確認する",
        "popup_subtitle": "完成次第、ご購入手続きに進めます。"
      },
      "list_discount": {
        "banner": "期間限定：フォトブック{{v1}}%OFF"
      },
      "low_quality_warning": {
        "action_keep": "そのまま使用",
        "action_remove": "注文から削除",
        "banner": {
          "cta": "写真を確認",
          "text": "推奨解像度を下回っている写真があります。印刷時にぼやける可能性があります",
          "title": "低解像度の写真を確認"
        },
        "text": "この写真は解像度が低いため、ぼやけて印刷される可能性があります。",
        "title": "画質が低い写真",
        "warning": {
          "cta": "差し替える",
          "cta_try_in_size": "{{sizeName}}で試す",
          "label": "低解像度の写真"
        }
      },
      "materials": {
        "canvas": "キャンバス",
        "classic": "クラシックフレーム",
        "frameless": "フレームレス",
        "sticker": "ステッカー",
        "wide_frame": "ワイドフレーム"
      },
      "materials_detailed_descriptions": {
        "canvas": "上質なキャンバス素材でワンランク上の仕上がり。コットンキャンバスにプリント、マグネット式で簡単取り付け。",
        "classic": "クラシックでプレミアムな印象。上質な紙にプリント、マグネット式で簡単取り付け。",
        "frameless": "ミニマルでモダンなデザイン。上質な紙にプリント、マグネット式で簡単取り付け。",
        "wide_frame": "存在感のあるエレガントな仕上がり。上質な紙にプリント、マグネット式で簡単取り付け。"
      },
      "materials_plural": {
        "classic": "クラシックフレーム",
        "wide_frame": "ワイドフレーム"
      },
      "mats": {
        "deep": "太め",
        "heart": "ハート",
        "medium": "ふつう",
        "none": "なし",
        "round": "ラウンド",
        "shallow": "細め"
      },
      "promo_code_errors": {
        "messages": {
          "already_a_user": "このプロモコードは初回購入のお客様限定です",
          "already_registered": "このコードは既に登録済みです",
          "default": "このコードはご利用いただけません",
          "expired": "このコードは有効期限が切れています",
          "non_existing": "このコードは存在しません",
          "quantity_exceeded": "このコードは既に入力済みです。最初にコードを入力した端末に戻り、購入手続きにお進みください",
          "redemptions_per_customer_exceeded": "このコードは既に使用済みです",
          "self_referral": "このコードはお友達紹介用です",
          "server_error": "コードの確認中にエラーが発生しました。もう一度お試しいただくか、サポートまでお問い合わせください。"
        },
        "titles": {
          "gift_card_empty": "このギフトカードは使い切りました",
          "gift_card_inactive": "このギフトカードは有効ではありません"
        }
      },
      "styles": {
        "mixed_styles": "ミックス"
      },
      "tile_actions": {
        "adjust": "トリミング調整",
        "remove": "削除",
        "remove_photo": "写真を削除",
        "replace": "写真を差し替え",
        "replace2": "差し替え",
        "replace_subtitle": "現在の写真から選ぶか、新しい写真をアップロード"
      },
      "upload_failed": {
        "action_continue": "続ける",
        "format_not_supported": "対応していないファイル形式です。JPGまたはPNGに変換してください。",
        "text": "写真のアップロード中に問題が発生しました。もう一度お試しいただくか、別の写真をお選びください。",
        "title": "アップロードに失敗しました"
      },
      "upload_photo": "写真をアップロード",
      "upload_photos": "写真をアップロード",
      "what_to_add": "何を追加しますか？"
    },
    "cart_upsells": {
      "bath_time": {
        "card_title_dog": "わんちゃんをおもしろバスタイムアートに！",
        "card_title_cat": "ねこちゃんをおもしろバスタイムアートに！",
        "card_cta": "今すぐ見る",
        "flow_title": "バスタイム"
      },
      "card_dismiss": "閉じる",
      "wall_subtitle_one": "タイル{{count}}枚、{{size}}",
      "wall_subtitle_other": "タイル{{count}}枚、{{size}}",
      "add_tiles_one": "タイルを{{count}}枚追加",
      "add_tiles_other": "タイルを{{count}}枚追加",
      "select_tiles_to_add": "追加するタイルを選んでください",
      "select_tiles_to_continue": "続けるにはタイルを選んでください",
      "wall_tile": "タイル{{position}}"
    },
    "order_management": {
      "actions": {
        "change_address": "住所を変更",
        "edit_order": "注文を編集",
        "duplicate_order": "再注文",
        "tracking_details": {
          "base": "配送状況",
          "not_shipped_suffix": "（発送後に表示）"
        },
        "edit_order_dialog": {
          "title": "キャンセルして編集しますか？",
          "subtitle": "注文をキャンセルして内容を変更できます。",
          "refund_info": "{{v1}}のクレジットが付与されます。返金をご希望の場合は、キャンセル後にサポートまでお問い合わせください。",
          "button": "キャンセルして編集",
          "go_back": "注文をそのままにする"
        },
        "view_order_summary": "注文概要を見る"
      },
      "already_shipped_dialog": {
        "cancel_text": "この注文は既に製造工程に入っているため、キャンセルできません。",
        "cancel_title": "キャンセルできません",
        "update_text": "この注文は既に製造工程に入っているため、変更できません。",
        "update_title": "変更できません",
        "ok": "了解"
      },
      "got_it": "了解",
      "modifying_existing_order_dialog": {
        "ok": "了解",
        "text": "変更するとお届け日が変わる場合があります",
        "title": "注文を変更中"
      },
      "order_card": {
        "created_at": "注文日",
        "delivered_at": "配達完了日",
        "expected_arrival": "お届け予定日",
        "number_of_photo_books": "フォトブック数",
        "number_of_tiles": "タイル数",
        "order_number_prefix": "注文番号"
      },
      "order_processing": {
        "cant_view_file": "ダウンロードできません。別のブラウザでお試しください"
      },
      "order_processing_dialog": {
        "text": "注文を処理中です。数分後にもう一度お試しください。",
        "title": "注文処理中"
      },
      "statuses2": {
        "approved": "製造中",
        "cancelled": "キャンセル済み",
        "complete": "配達完了",
        "processing": "処理中...",
        "shipped": "配送中"
      },
      "title": "ご注文情報"
    },
    "out_of_stock": {
      "applied_to_other_materials": "他の素材に適用されました",
      "applied_to_x": "{{v1}}に適用されました",
      "applied_where_available": "利用可能な箇所に適用されました",
      "available_in_other_materials": "他の素材で利用可能",
      "available_in_other_sizes": "他のサイズで利用可能",
      "only_available_for_x": "{{v1}}のみ対応",
      "some_tiles_arent_available_for_this_option": "一部のタイルはこのオプションに対応していません",
      "undo": "元に戻す",
      "we_changed_some_frame_that_werent_available": "在庫切れのタイルを変更しました",
      "x_available_in_selected_materials": "{{v1}}は選択中の素材でご利用いただけます",
      "x_isnt_available_in_x": "{{v1}}は{{v2}}では利用できません",
      "x_isnt_available_size_changed_to_x_subtitle": [
        "サイズを{{v1}}に変更しました"
      ],
      "x_isnt_available_size_changed_to_x_title": [
        "{{v1}}は在庫切れです"
      ],
      "x_only_available_in_x": "{{v1}}は{{v2}}のみ対応",
      "x_x_isnt_available": "{{v1}} {{v2}}は在庫切れです",
      "x_x_isnt_available_color_changed_to_x_subtitle": [
        "カラーを{{v1}}に変更しました"
      ],
      "x_x_isnt_available_color_changed_to_x_title": [
        "{{v1}} {{v2}}は在庫切れです"
      ]
    },
    "photo": {
      "edit_tile": "編集",
      "photo_tiles": "フォトタイル"
    },
    "photo_book": {
      "product_names": {
        "newborn": "赤ちゃんフォトブック",
        "family": "ファミリーフォトブック",
        "annual": "年間フォトブック",
        "travel": "トラベルフォトブック",
        "wedding": "ウェディングフォトブック"
      },
      "add_photos_dialog": {
        "title": "新しい写真をどこに配置しますか？",
        "add_chronologically": "日付順に追加",
        "add_at_end": "最後に追加"
      },
      "arrange": {
        "name": "並び替え"
      },
      "arrival_notice": {
        "login_title_one": "おかえりなさい。フォトブック{{count}}冊をバッグに復元しました",
        "login_title_other": "おかえりなさい。フォトブック{{count}}冊をバッグに復元しました",
        "title_one": "フォトブック{{count}}冊をバッグに復元しました",
        "title_other": "フォトブック{{count}}冊をバッグに復元しました"
      },
      "low_res_photos": {
        "cart_cta": "確認",
        "cart_label": "低解像度の写真があります"
      },
      "not_enough_photos": {
        "cart_cta": "追加",
        "cart_label": "あと{{numPhotos}}枚追加して完成です。",
        "cart_title": "フォトブックにもっと写真を追加",
        "cta": "写真を追加",
        "subtitle": "{{totalAmount}}枚に満たないため、あと{{missingAmount}}枚追加してください",
        "title": "写真が足りません"
      },
      "too_many_pages": {
        "title": "あと少しです！写真が少し多すぎます",
        "subtitle": "フォトブックに入れられる写真は最大{{maxPhotos}}枚です。ブックを完成させるには{{extraPhotos}}枚削除してください。",
        "cta": "ブックを編集する"
      },
      "photo_deleted": "写真を削除しました",
      "photos_not_uploaded": {
        "title": "{{count}}枚の写真がアップロード未完了です",
        "subtitle": "購入手続きの前にもう一度追加してください"
      },
      "photo_limit": {
        "title": "写真の上限に達しました",
        "message": "写真の上限に達しました。追加するには一部を削除してください",
        "subtitle_single": "1枚削除してください",
        "subtitle_plural": "{{v1}}枚削除してください",
        "all_set": "準備完了！「{{done}}」をタップして続行"
      },
      "swipe_pages": "ページをスワイプ",
      "creating_book": "ブックを作成中...",
      "updating_book": "ブックを更新中...",
      "replacing_photo": "写真を差し替え中...",
      "uploading_photos": "写真をアップロード中",
      "empty_book": "ブックが空です",
      "title": "タイトル",
      "photo": "写真",
      "added_in_chronological_order": "日付順に追加しました",
      "default_cover_text": "Happy Moments",
      "size": "サイズ",
      "cover": "カバー",
      "pages_disabled_message": "ページの並び替えにはもう少し写真が必要です",
      "page_order": {
        "title": "ページ一覧",
        "subtitle": "ドラッグして並び替え",
        "sort_by_date": "日付順に並び替え",
        "done": "完了",
        "sort_confirmation": {
          "title": "ページを日付順に並び替え",
          "main_text": "古い順に並び替えます",
          "approve": "並び替え",
          "dismiss": "キャンセル"
        },
        "snackbar": {
          "pages_sorted": "ページを並び替えました",
          "pages_sorted_by_date": "日付順に並び替えました",
          "undo": "元に戻す",
          "cover_back_cant_edit": "裏表紙は編集できません"
        },
        "warning": {
          "missing_date": "日付情報のない写真は自動並び替えされません。手動で配置してください"
        }
      },
      "cover_edit": {
        "title": "カバーを編集",
        "title_label": "タイトル",
        "title_font_label": "タイトルフォント",
        "cover_photo_label": "カバー写真",
        "designed_covers": "デザイン済みカバー",
        "upload": "アップロード",
        "designs": "デザイン",
        "select_cover": "カバーを選択",
        "crop_and_title_hint": "ピンチでトリミング、タイトルをタップして編集",
        "ai_cover_create": "作成",
        "ai_cover_title": "本のタイトル",
        "ai_cover_headline_label": "本のタイトル",
        "ai_cover_headline_placeholder": "本のタイトル",
        "ai_cover_generate": "表紙を作成",
        "ai_cover_retry": "再試行",
        "ai_cover_creating": "表紙を作成中",
        "ai_cover_ready_title": "表紙が完成しました",
        "ai_cover_ready_action": "編集"
      },
      "cover_deep_link": {
        "rejected_title": "エラーが発生しました。もう一度表紙を選んでください"
      },
      "deep_link_photos": {
        "rejected_title": "エラーが発生しました。写真を追加してブックを作成してください"
      },
      "add_text": "テキスト",
      "size_selection": {
        "title": "ブックサイズを選択",
        "select_size": "サイズを選択",
        "page_count": "ページ数",
        "tier_page_range": "{{start}}〜{{end}}ページ",
        "current_tier": "現在のプラン"
      },
      "page_controls": {
        "replace_photo": "差し替え",
        "delete_photo": "削除",
        "adjust_crop": "ピンチでトリミング調整",
        "caption_too_long": "テキストが長すぎます"
      },
      "page_1": "1ページ目",
      "page_single": "{{page}}ページ目",
      "page_range": "{{start}}〜{{end}}ページ",
      "turn_pages": "ページをめくる",
      "ios_uploader": {
        "old_ux_message": "「追加」を押した後、30秒ほど読み込みをお待ちください",
        "old_ux_upload": "写真をアップロード"
      }
    },
    "pitch": {
      "copyright": "© Copyright 2015-{{v1}} Mixtiles, LTD",
      "footer": {
        "about": "Mixtilesについて",
        "accessibility": "アクセシビリティ",
        "blog": "ブログ",
        "canvas_prints": "キャンバスプリント",
        "careers": "採用情報",
        "facebook": "Facebook",
        "follow_us": "フォローする",
        "gallery_walls": "ギャラリーウォール",
        "impressum": "運営者情報",
        "instagram": "Instagram",
        "join_us": "Mixtilesエンジニア採用情報",
        "privacy": "プライバシーポリシー",
        "cookie_policy": "Cookieポリシー",
        "products": "商品",
        "resources": "サポート情報",
        "terms_of_use": "利用規約",
        "twitter": "X",
        "tokushoho": "特定商取引法に基づく表記"
      },
      "footer_links": {
        "accessibility_statement": "アクセシビリティ",
        "impressum": "運営者情報",
        "privacy_policy": "プライバシーポリシー",
        "cookie_policy": "Cookieポリシー",
        "terms_of_use": "利用規約"
      },
      "global_shipping": "世界中へスピーディーにお届け",
      "headline": "お気に入りの写真を、\n手軽に美しいウォールアートに",
      "icons": {
        "satisfaction": {
          "text": "ご満足いただけない場合は全額返金",
          "title": "お客様満足保証"
        }
      },
      "main_button_cta": "はじめる"
    },
    "product_selection": {
      "photo_books_name": "フォトブック",
      "tiles_name": "タイル",
      "title_choose_what_to_create": "何を作りますか？"
    },
    "rating": {
      "back_to_mixtiles": "Mixtilesに戻る",
      "comment": {
        "1-2-stars": {
          "sentence": "ご不便をおかけして申し訳ございません。改善点をお聞かせください。"
        },
        "3-4-stars": {
          "question": "改善できる点はありますか？",
          "sentence": "もっと良くしていきたいです！"
        },
        "5-stars": {
          "question": "特に気に入った点は？",
          "sentence": "嬉しいお言葉ありがとうございます！"
        }
      },
      "contact_us": "お問い合わせ",
      "feel_free": "お困りのことがございましたら、お気軽に",
      "first_question": "Mixtilesでのお買い物体験はいかがでしたか？",
      "next": "次へ",
      "star_caption": {
        "1": "非常に不満",
        "2": "不満",
        "3": "普通",
        "4": "満足",
        "5": "とても満足"
      },
      "submit": "送信",
      "tell_us_here": "ご意見をお聞かせください（任意）",
      "thanks": "フィードバックありがとうございます！"
    },
    "refresher_kit_request": {
      "back": "戻る",
      "confirmation": {
        "received_title": "リクエストを受け付けました！"
      },
      "contact_support": "サポートに問い合わせる",
      "continue": "次へ",
      "continue_with_count": "次へ ({{count}})",
      "errors": {
        "invalid_email": "有効なメールアドレスを入力してください",
        "invalid_state": "有効な州を入力してください",
        "invalid_submission": "このリクエストを受け付けられませんでした。選択内容と入力内容をご確認のうえ、もう一度お試しください。",
        "load_failed": "問題が発生しました。",
        "required": "必須",
        "submit_failed": "リクエストを送信できませんでした。もう一度お試しください。"
      },
      "expired": {
        "body": "サポートチームにお問い合わせいただければ、新しいリンクをお送りします。",
        "title": "このリンクは有効期限が切れています"
      },
      "frame_name": "{{v1}}フレーム",
      "inactive": {
        "body": "サポートチームにお問い合わせください。解決までお手伝いします。",
        "title": "このリンクは無効になりました"
      },
      "invalid_link": {
        "body": "サポートチームにお問い合わせください。解決までお手伝いします。",
        "title": "このリンクは無効です"
      },
      "no_orders": {
        "body": "サポートチームにお問い合わせください。解決までお手伝いします。",
        "title": "このアカウントに配達済みの注文が見つかりませんでした"
      },
      "select": {
        "title": "リフレッシュが必要なタイルを選んで、交換用の粘着シートを受け取りましょう"
      },
      "selected_badge": "{{v1}}枚選択中",
      "selected_of_tiles": "{{v1}}/{{v2}}枚",
      "sending": "リクエストを送信しています...",
      "shipping": {
        "country": "国",
        "email": "メールアドレス",
        "submit": "キットを受け取る",
        "subtitle": "交換用の粘着シートは無料でお届けします。",
        "title": "お届け先を教えてください"
      },
      "summary": {
        "adhesives_many": "交換用粘着シート {{v1}}点",
        "adhesives_one": "交換用粘着シート 1点",
        "title": "注文内容（{{v1}}）"
      },
      "switch_account": "アカウントを切り替える",
      "tile_count_many": "{{v1}}枚",
      "tile_count_one": "1枚",
      "try_again": "もう一度試す",
      "wrong_account": {
        "body": "このリンクが送信されたアカウントでログインするか、サポートチームにお問い合わせください。",
        "title": "このリンクは別のアカウントのものです"
      }
    },
    "referral": {
      "already_referred": "この方にはすでにギフトカードを送信済みです。別のメールアドレスをご入力ください。",
      "general_error": "ギフトカードの送信中にエラーが発生しました。しばらくしてからもう一度お試しください。",
      "login": "ログインして続ける",
      "menu_title": "お友達紹介プログラム",
      "referral_sent": "<div>ギフトカードを <b>{{v1}}</b> に送信しました！<br>お友達が購入すると、<b>{{v2}}</b> のクレジットが付与されます。メールでお知らせします。</div>",
      "self_referral": "ご自身のメールアドレスには送信できません。別のメールアドレスをご入力ください。",
      "send": "今すぐ送る",
      "subtitle": "お友達が購入するたびに{{v1}}のクレジットをプレゼント。",
      "title": "お友達に{{v1}}、あなたにも{{v1}}"
    },
    "size_selection": {
      "price_per_tile": "1枚あたり{{v1}}"
    },
    "wall_designer": {
      "highlighted_tile": {
        "edit_tile": "タイルを編集",
        "swap_position": "位置を入れ替え",
        "swap_position_title": "入れ替える写真を選んでください"
      },
      "photos_selector": {
        "selected": "選択中",
        "title": "{{v1}}枚の写真を選択"
      },
      "preferences_saved": {
        "cta": "トップページに戻る",
        "subtitle": "また新しい商品やお得な情報をお届けします",
        "title": "設定が保存されました"
      },
      "zoom_button": {
        "full_view": "全体を見る",
        "zoom": "ズーム"
      }
    },
    "wall_feed": {
      "categories": {
        "large": "大きめ",
        "medium": "標準",
        "small": "小さめ"
      }
    },
    "product": {
      "carousel": {
        "peel_stick": "剥がして、ピタッと貼るだけ",
        "adjust_to_perfection": "調整も差し替えも、自由に",
        "no_damage": "壁を傷つけない"
      }
    },
    "product_page": {
      "reviews_count": "App Storeで10万件以上の評価",
      "tile_product": {
        "title": {
          "regular": "壁に貼れるフォトタイル",
          "canvas": "貼るだけキャンバスプリント"
        },
        "tile": "タイル",
        "description": "Mixtiles（ミックスタイルズ）のフォトタイル。釘不要、壁に傷をつけず賃貸でも安心。",
        "description_mobile": {
          "no_nails": "釘不要、貼って飾れる",
          "satisfaction": "お客様満足保証"
        }
      },
      "art_product": {
        "description": "釘不要、壁に傷をつけないウォールアート。賃貸でも安心。",
        "description_mobile": {
          "no_nails": "釘不要、貼って飾れる",
          "satisfaction": "お客様満足保証"
        }
      },
      "photobook_product": {
        "title": {
          "default": "かんたんフォトブック"
        },
        "description": "数タップでデザイン、3Dプレビューで仕上がりをチェック。",
        "bullet_points": {
          "same_price": "ページ数に関わらず同一価格",
          "simple_pricing": "シンプルでわかりやすい料金",
          "no_hidden_fees": "追加料金なし",
          "free_shipping": "送料無料"
        },
        "description_mobile": {
          "fixed_price": "ページ数に関わらず同一価格",
          "quality_book": "高品質プリント、ハードカバー仕上げ",
          "free_shipping": "送料無料"
        },
        "beauty": {
          "title": "すべてのページに美しさを",
          "subtitle": "すべてのブックはハードカバー仕上げ。シルクのような手触りのプレミアムな紙に印刷されます"
        }
      },
      "reviews_count_mobile": "10万件以上の評価",
      "price_each": "/枚",
      "choose_your_own_style": "お好みのスタイルをお選びください",
      "controls": {
        "frame_style": "フレームスタイル",
        "frame_size": "フレームサイズ",
        "tile": {
          "start": "作成をはじめる"
        },
        "art": {
          "start": "アートを追加",
          "browse": "アートを見る"
        },
        "photobook": {
          "start": "商品を見る"
        }
      },
      "magnetic_hanging": {
        "title": "マグネット取り付けの仕組み",
        "description": "マグネットで簡単に位置合わせができます。壁に傷をつけないため、賃貸のお部屋でも安心です。"
      },
      "community": {
        "title": "みんなの飾り方",
        "description": "Mixtilesをお使いのお客様からいただいた声をご紹介します",
        "load_more": "もっと見る"
      },
      "explore": {
        "photo_tiles": "フォトタイルを見る",
        "canvas_prints": "キャンバスプリントを見る",
        "art": "アートを見る",
        "photo_books": "フォトブックを見る"
      }
    },
    "tile_upsell": {
      "title": "ご注文完了！",
      "centerpiece": {
        "title": "壁掛けプレートを追加しませんか？",
        "subtitle": "{{price}}から",
        "button": "カスタマイズする"
      },
      "collage": {
        "title": "写真のコラージュはギフトにもぴったり",
        "subtitle": "{{size}} {{price}}",
        "button": "カスタマイズする"
      },
      "referral": {
        "title": "お友達にMixtilesを紹介しませんか？",
        "subtitle": "このリンクで{{price}}円OFF",
        "button": "リンクをシェア"
      }
    },
    "cancel_order_v2": {
      "cta": "注文をキャンセル",
      "dialog": {
        "title": "注文をキャンセル",
        "refund_content": "{{sum}}の全額返金を行います。",
        "refund_refund_info": "返金は元のお支払い方法に適用されます。",
        "dismiss": "注文をそのままにする"
      }
    },
    "seo": {
      "art": {
        "base": {
          "title": "アートワーク | Mixtiles",
          "description": "お気に入りの写真を、手軽に美しいウォールアートに"
        }
      },
      "canvas": {
        "base": {
          "title": "キャンバスプリント | Mixtiles",
          "h1": "オリジナルキャンバスプリント",
          "description": "お気に入りの写真を美しいキャンバスプリントに。釘も工具も不要、貼るだけで飾れます。"
        },
        "sized": {
          "title": "{{size}} キャンバスプリント | Mixtiles",
          "h1": "{{size}} キャンバスプリント",
          "description": "写真を美しい{{size}}キャンバスプリントに。釘不要、壁を傷つけない簡単ウォールアート。"
        }
      },
      "phototiles": {
        "base": {
          "title": "壁に貼れるフォトパネル | Mixtiles",
          "h1": "壁に貼れるフォトパネル",
          "description": "写真をおしゃれなフォトパネルに。Mixtiles（ミックスタイルズ）のフォトタイルなら壁に穴をあけずに貼るだけで飾れます。"
        },
        "sized": {
          "title": "{{size}} フォトパネル | Mixtiles",
          "h1": "{{size}} フォトパネル",
          "description": "写真を{{size}}のフォトパネルに。Mixtilesのフォトタイルなら壁に穴をあけずに飾れます。"
        },
        "withMaterial": {
          "title": "{{size}} {{frameDisplay}} フォトパネル | Mixtiles",
          "h1": "{{size}} {{frameDisplay}} フォトパネル",
          "description": "写真を{{size}} {{frameDisplayLower}}のフォトパネルに。Mixtilesのフォトタイルなら壁に穴をあけずに飾れます。"
        }
      },
      "photobooks": {
        "base": {
          "title": "フォトブック | Mixtiles",
          "h1": "フォトブック",
          "description": "Mixtilesで美しいフォトブックを作りましょう。大切な思い出を、一生の宝物に。"
        },
        "sized": {
          "title": "フォトブック {{size}} | Mixtiles",
          "h1": "フォトブック {{size}}",
          "description": "{{description}}"
        },
        "wedding": {
          "title": "ウェディングフォトブック | Mixtiles",
          "h1": "ウェディングフォトブック",
          "description": "ふたりの歩みをMixtilesのウェディングフォトブックに。大切な一日を一生の宝物に。",
          "sized": {
            "title": "ウェディングフォトブック {{size}} | Mixtiles",
            "h1": "ウェディングフォトブック {{size}}"
          }
        },
        "memory": {
          "title": "思い出フォトブック | Mixtiles",
          "h1": "思い出フォトブック",
          "description": "大切な思い出をMixtilesの思い出フォトブックに。忘れたくない瞬間を一冊に。",
          "sized": {
            "title": "思い出フォトブック {{size}} | Mixtiles",
            "h1": "思い出フォトブック {{size}}"
          }
        },
        "small": {
          "title": "ミニフォトブック | Mixtiles",
          "h1": "ミニフォトブック",
          "description": "コンパクトで高品質。Mixtilesのミニフォトブックで大切な瞬間を手元に。",
          "sized": {
            "title": "ミニフォトブック {{size}} | Mixtiles",
            "h1": "ミニフォトブック {{size}}"
          }
        },
        "boudoir": {
          "title": "プライベートフォトブック | Mixtiles",
          "h1": "プライベートフォトブック",
          "description": "ありのままの美しさを一冊に。Mixtilesのプライベートフォトブック。",
          "sized": {
            "title": "プライベートフォトブック {{size}} | Mixtiles",
            "h1": "プライベートフォトブック {{size}}"
          }
        },
        "travel": {
          "title": "トラベルフォトブック | Mixtiles",
          "h1": "トラベルフォトブック",
          "description": "旅の思い出をMixtilesのトラベルフォトブックに。冒険の記録を一冊に。",
          "sized": {
            "title": "トラベルフォトブック {{size}} | Mixtiles",
            "h1": "トラベルフォトブック {{size}}"
          }
        },
        "coffee-table": {
          "title": "飾れるフォトブック | Mixtiles",
          "h1": "飾れるフォトブック",
          "description": "リビングやローテーブルに映えるフォトブック。Mixtilesで、思い出をスタイリッシュな一冊に。",
          "sized": {
            "title": "飾れるフォトブック {{size}} | Mixtiles",
            "h1": "飾れるフォトブック {{size}}"
          }
        },
        "engagement": {
          "title": "婚約記念フォトブック | Mixtiles",
          "h1": "婚約記念フォトブック",
          "description": "ふたりの物語をMixtilesの婚約記念フォトブックに。一生の宝物になる一冊。",
          "sized": {
            "title": "婚約記念フォトブック {{size}} | Mixtiles",
            "h1": "婚約記念フォトブック {{size}}"
          }
        },
        "family": {
          "title": "ファミリーフォトブック | Mixtiles",
          "h1": "ファミリーフォトブック",
          "description": "家族の大切な瞬間をMixtilesのファミリーフォトブックに。何度でも見返したくなる一冊。",
          "sized": {
            "title": "ファミリーフォトブック {{size}} | Mixtiles",
            "h1": "ファミリーフォトブック {{size}}"
          }
        },
        "anniversary": {
          "title": "記念日フォトブック | Mixtiles",
          "h1": "記念日フォトブック",
          "description": "ふたりの歩みをMixtilesの記念日フォトブックに。年月を重ねた思い出を美しく。",
          "sized": {
            "title": "記念日フォトブック {{size}} | Mixtiles",
            "h1": "記念日フォトブック {{size}}"
          }
        },
        "pet-dog": {
          "title": "愛犬フォトアルバム | Mixtiles",
          "h1": "愛犬フォトアルバム",
          "description": "大切な家族の一員、愛犬との思い出をMixtilesのフォトアルバムに。",
          "sized": {
            "title": "愛犬フォトアルバム {{size}} | Mixtiles",
            "h1": "愛犬フォトアルバム {{size}}"
          }
        },
        "mothers-day": {
          "title": "母の日フォトブック | Mixtiles",
          "h1": "母の日フォトブック",
          "description": "お母さんに世界でひとつの贈り物を。Mixtilesの母の日フォトブックに感謝を込めて。",
          "sized": {
            "title": "母の日フォトブック {{size}} | Mixtiles",
            "h1": "母の日フォトブック {{size}}"
          }
        },
        "christmas": {
          "title": "クリスマスフォトブック | Mixtiles",
          "h1": "クリスマスフォトブック",
          "description": "クリスマスの思い出をMixtilesのフォトブックに。毎年大切にしたくなる一冊。",
          "sized": {
            "title": "クリスマスフォトブック {{size}} | Mixtiles",
            "h1": "クリスマスフォトブック {{size}}"
          }
        },
        "fathers-day": {
          "title": "父の日フォトブック | Mixtiles",
          "h1": "父の日フォトブック",
          "description": "お父さんへの感謝を込めて。Mixtilesの父の日フォトブックで思い出を一冊に。",
          "sized": {
            "title": "父の日フォトブック {{size}} | Mixtiles",
            "h1": "父の日フォトブック {{size}}"
          }
        },
        "retirement": {
          "title": "退職記念フォトブック | Mixtiles",
          "h1": "退職記念フォトブック",
          "description": "新しい門出を祝う。Mixtilesの退職記念フォトブックでこれまでの歩みを振り返る。",
          "sized": {
            "title": "退職記念フォトブック {{size}} | Mixtiles",
            "h1": "退職記念フォトブック {{size}}"
          }
        },
        "birthday": {
          "title": "誕生日フォトブック | Mixtiles",
          "h1": "誕生日フォトブック",
          "description": "誕生日の思い出を一冊のアルバムに。Mixtilesのフォトブックで毎年の特別な瞬間を残そう。",
          "sized": {
            "title": "誕生日フォトブック {{size}} | Mixtiles",
            "h1": "誕生日フォトブック {{size}}"
          }
        },
        "graduation": {
          "title": "卒業記念フォトブック | Mixtiles",
          "h1": "卒業記念フォトブック",
          "description": "卒業という節目に、Mixtilesのフォトブックを。仲間との思い出を一生の宝物に。",
          "sized": {
            "title": "卒業記念フォトブック {{size}} | Mixtiles",
            "h1": "卒業記念フォトブック {{size}}"
          }
        },
        "yearly": {
          "title": "年間フォトブック | Mixtiles",
          "h1": "年間フォトブック",
          "description": "一年の思い出をMixtilesの年間フォトブックに。とっておきの瞬間を一冊に。",
          "sized": {
            "title": "年間フォトブック {{size}} | Mixtiles",
            "h1": "年間フォトブック {{size}}"
          }
        },
        "valentines": {
          "title": "バレンタインフォトブック | Mixtiles",
          "h1": "バレンタインフォトブック",
          "description": "愛を込めてMixtilesのバレンタインフォトブックを。ふたりだけの思い出を一冊に。",
          "sized": {
            "title": "バレンタインフォトブック {{size}} | Mixtiles",
            "h1": "バレンタインフォトブック {{size}}"
          }
        },
        "recipe": {
          "title": "レシピフォトブック | Mixtiles",
          "h1": "レシピフォトブック",
          "description": "レシピをおしゃれなフォトブックに。Mixtilesで自分だけの料理本を作ろう。",
          "sized": {
            "title": "レシピフォトブック {{size}} | Mixtiles",
            "h1": "レシピフォトブック {{size}}"
          }
        },
        "deals": {
          "title": "フォトブックセール | Mixtiles",
          "h1": "フォトブックセール",
          "description": "Mixtilesのフォトブックをお得に。大切な思い出を一冊にまとめよう。",
          "sized": {
            "title": "フォトブックセール {{size}} | Mixtiles",
            "h1": "フォトブックセール {{size}}"
          }
        },
        "designed-covers": {
          "title": "デザインカバーフォトブック | Mixtiles",
          "h1": "デザインカバーフォトブック",
          "description": "Mixtilesのデザインカバーフォトブックで、思い出を上品な一冊に。美しいカバーから選んで、自慢したくなる宝物に。",
          "sized": {
            "title": "デザインカバーフォトブック {{size}} | Mixtiles",
            "h1": "デザインカバーフォトブック {{size}}"
          }
        },
        "baby": {
          "title": "ベビーフォトブック | Mixtiles",
          "h1": "ベビーフォトブック",
          "description": "赤ちゃんの一年をMixtilesのベビーフォトブックに。お気に入りの写真を選んでタイトルを添えるだけ。何度でも開きたくなる一冊。",
          "sized": {
            "title": "ベビーフォトブック {{size}} | Mixtiles",
            "h1": "ベビーフォトブック {{size}}"
          }
        },
        "wedding-designed-covers": {
          "title": "ウェディングデザインカバーフォトブック | Mixtiles",
          "h1": "ウェディングデザインカバーフォトブック",
          "description": "結婚式の写真にぴったりのデザインカバーを選ぶだけ。Mixtilesが、ずっと飾っておきたい一冊に仕上げます。",
          "sized": {
            "title": "ウェディングデザインカバーフォトブック {{size}} | Mixtiles",
            "h1": "ウェディングデザインカバーフォトブック {{size}}"
          }
        },
        "baby-designed-covers": {
          "title": "ベビーデザインカバーフォトブック | Mixtiles",
          "h1": "ベビーデザインカバーフォトブック",
          "description": "赤ちゃん向けのデザインカバーを選んで、最初の一年をページに。レイアウトはMixtilesにおまかせ。",
          "sized": {
            "title": "ベビーデザインカバーフォトブック {{size}} | Mixtiles",
            "h1": "ベビーデザインカバーフォトブック {{size}}"
          }
        },
        "birthday-designed-covers": {
          "title": "誕生日デザインカバーフォトブック | Mixtiles",
          "h1": "誕生日デザインカバーフォトブック",
          "description": "一年分の誕生日の写真を、その日のためのデザインカバーで包んで。選んで写真を入れるだけで贈り物に。",
          "sized": {
            "title": "誕生日デザインカバーフォトブック {{size}} | Mixtiles",
            "h1": "誕生日デザインカバーフォトブック {{size}}"
          }
        },
        "coffee-table-designed-covers": {
          "title": "飾れるデザインカバーフォトブック | Mixtiles",
          "h1": "飾れるデザインカバーフォトブック",
          "description": "リビングに置いておきたくなるデザインカバー。お気に入りの写真を選べば、Mixtilesが上品な一冊に仕上げます。",
          "sized": {
            "title": "飾れるデザインカバーフォトブック {{size}} | Mixtiles",
            "h1": "飾れるデザインカバーフォトブック {{size}}"
          }
        },
        "proposal-designed-covers": {
          "title": "プロポーズデザインカバーフォトブック | Mixtiles",
          "h1": "プロポーズデザインカバーフォトブック",
          "description": "プロポーズの日を一冊の本に。デザインカバーを選んで写真を入れれば、あの「はい」を何度でも。",
          "sized": {
            "title": "プロポーズデザインカバーフォトブック {{size}} | Mixtiles",
            "h1": "プロポーズデザインカバーフォトブック {{size}}"
          }
        },
        "christmas-designed-covers": {
          "title": "クリスマスデザインカバーフォトブック | Mixtiles",
          "h1": "クリスマスデザインカバーフォトブック",
          "description": "クリスマスの写真に、季節にぴったりのデザインカバーを。毎年開きたくなる一冊が作れます。",
          "sized": {
            "title": "クリスマスデザインカバーフォトブック {{size}} | Mixtiles",
            "h1": "クリスマスデザインカバーフォトブック {{size}}"
          }
        },
        "family-designed-covers": {
          "title": "ファミリーデザインカバーフォトブック | Mixtiles",
          "h1": "ファミリーデザインカバーフォトブック",
          "description": "家族のフォトブックにデザインカバーを選んで。何気ない日常が、みんなで見返したくなる宝物に。",
          "sized": {
            "title": "ファミリーデザインカバーフォトブック {{size}} | Mixtiles",
            "h1": "ファミリーデザインカバーフォトブック {{size}}"
          }
        },
        "school-years-designed-covers": {
          "title": "スクールイヤーデザインカバーフォトブック | Mixtiles",
          "h1": "スクールイヤーデザインカバーフォトブック",
          "description": "学校生活の思い出を一冊に。デザインカバーを選べば、ページが年々埋まっていきます。",
          "sized": {
            "title": "スクールイヤーデザインカバーフォトブック {{size}} | Mixtiles",
            "h1": "スクールイヤーデザインカバーフォトブック {{size}}"
          }
        }
      },
      "variant_links": {
        "phototiles_material": "{{frameDisplay}} フォトタイル"
      }
    }
  }
}
